"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceSortFields = exports.PlanSortFields = exports.PaymentMethodType = exports.PaymentCollection = exports.PackageStatus = exports.PackageEntitlementSortFields = exports.PackageDtoSortFields = exports.MonthlyAccordingTo = exports.MeterType = exports.MemberStatus = exports.MemberSortFields = exports.IntegrationSortFields = exports.ImportIntegrationTaskSortFields = exports.HookStatus = exports.HookSortFields = exports.FontWeight = exports.FeatureType = exports.FeatureStatus = exports.FeatureSortFields = exports.ExperimentStatus = exports.ExperimentSortFields = exports.EventLogType = exports.ErrorCode = exports.EnvironmentSortFields = exports.EnvironmentProvisionStatus = exports.EntitySelectionMode = exports.EntitlementResetPeriod = exports.DiscountType = exports.DiscountDurationType = exports.Department = exports.CustomerSubscriptionSortFields = exports.CustomerSortFields = exports.CustomerResourceSortFields = exports.Currency = exports.CouponType = exports.CouponStatus = exports.CouponSortFields = exports.ConditionOperation = exports.ChangeType = exports.BillingVendorIdentifier = exports.BillingPeriod = exports.BillingModel = exports.BillingAnchor = exports.ApiKeyType = exports.ApiKeySortFields = exports.Alignment = exports.AggregationFunction = exports.AddonSortFields = exports.AccountStatus = exports.AccessDeniedReason = void 0;
exports.AddonFragmentDoc = exports.PackageEntitlementFragmentDoc = exports.ProductFragmentDoc = exports.CustomerFragmentDoc = exports.PromotionalEntitlementFragmentDoc = exports.CouponFragmentDoc = exports.SlimCustomerFragmentDoc = exports.SlimSubscriptionFragmentDoc = exports.TotalPriceFragmentDoc = exports.PriceFragmentDoc = exports.PriceTierFragmentDoc = exports.CustomerResourceFragmentDoc = exports.SubscriptionInvoiceFragmentDoc = exports.ExperimentGroupType = exports.WidgetType = exports.WeeklyAccordingTo = exports.VendorIdentifier = exports.UsageUpdateBehavior = exports.UsageMeasurementSortFields = exports.TrialPeriodUnits = exports.TiersMode = exports.TaskType = exports.TaskStatus = exports.SyncStatus = exports.SubscriptionStatus = exports.SubscriptionStartSetup = exports.SubscriptionScheduleType = exports.SubscriptionScheduleStatus = exports.SubscriptionPriceSortFields = exports.SubscriptionMigrationTime = exports.SubscriptionMigrationTaskSortFields = exports.SubscriptionInvoiceStatus = exports.SubscriptionEntitlementSortFields = exports.SubscriptionEndSetup = exports.SubscriptionDecisionStrategy = exports.SubscriptionCancellationTime = exports.SubscriptionCancellationAction = exports.SubscriptionCancelReason = exports.SubscriptionAddonSortFields = exports.SourceType = exports.SortNulls = exports.SortDirection = exports.PublishMigrationType = exports.ProvisionSubscriptionStatus = exports.ProrationBehavior = exports.PromotionalEntitlementStatus = exports.PromotionalEntitlementSortFields = exports.PromotionalEntitlementPeriod = exports.ProductSortFields = exports.PricingType = void 0;
exports.EstimateSubscriptionDocument = exports.CancelSubscriptionDocument = exports.UpdateSubscriptionDocument = exports.ImportSubscriptionsBulkDocument = exports.ApplySubscriptionDocument = exports.ProvisionSubscriptionDocument = exports.RevokePromotionalEntitlementDocument = exports.GrantPromotionalEntitlementsDocument = exports.UpdateCustomerDocument = exports.ImportCustomerDocument = exports.ImportCustomerBulkDocument = exports.ProvisionCustomerDocument = exports.UsageHistoryFragmentDoc = exports.PaywallFragmentDoc = exports.PaywallCalculatedPricePointsFragmentDoc = exports.PaywallConfigurationFragmentDoc = exports.LayoutConfigurationFragmentDoc = exports.PaywallCurrencyFragmentDoc = exports.MockPaywallPlanFragmentDoc = exports.MockPaywallAddonFragmentDoc = exports.MockPaywallPriceFragmentDoc = exports.MockPaywallPackageEntitlementFragmentDoc = exports.CheckoutStateFragmentDoc = exports.CheckoutConfigurationFragmentDoc = exports.CustomerPortalFragmentDoc = exports.CustomerPortalConfigurationFragmentDoc = exports.TypographyConfigurationFragmentDoc = exports.FontVariantFragmentDoc = exports.CustomerPortalBillingInformationFragmentDoc = exports.CustomerPortalPromotionalEntitlementFragmentDoc = exports.CustomerPortalEntitlementFragmentDoc = exports.CustomerPortalSubscriptionFragmentDoc = exports.CustomerPortalSubscriptionScheduledUpdateDataFragmentDoc = exports.CustomerPortalSubscriptionAddonFragmentDoc = exports.CustomerPortalSubscriptionPriceFragmentDoc = exports.EntitlementUsageUpdatedFragmentDoc = exports.UsageUpdatedFragmentDoc = exports.EntitlementsUpdatedPayloadFragmentDoc = exports.EntitlementFragmentDoc = exports.FeatureFragmentDoc = exports.ResetPeriodConfigurationFragmentDoc = exports.SubscriptionPreviewV2FragmentDoc = exports.SubscriptionPreviewInvoiceFragmentDoc = exports.ImmediateSubscriptionPreviewInvoiceFragmentDoc = exports.SubscriptionPreviewFragmentDoc = exports.CustomerWithSubscriptionsFragmentDoc = exports.SubscriptionFragmentDoc = exports.SubscriptionFutureUpdateDataFragmentDoc = exports.SubscriptionScheduledUpdateDataFragmentDoc = exports.PlanFragmentDoc = void 0;
exports.getSdk = exports.OnUsageUpdatedDocument = exports.OnEntitlementsUpdatedDocument = exports.GetUsageHistoryDocument = exports.GetMockPaywallDocument = exports.GetCheckoutStateDocument = exports.GetCustomerPortalByRefIdDocument = exports.GetSdkConfigurationDocument = exports.GetProductsDocument = exports.GetEntitlementDocument = exports.GetEntitlementsDocument = exports.GetPaywallDocument = exports.GetCouponsDocument = exports.GetActiveSubscriptionsDocument = exports.GetCustomerByIdDocument = exports.TransferSubscriptionDocument = exports.ArchiveCustomerDocument = exports.MigrateSubscriptionToLatestDocument = exports.CreateSubscriptionDocument = exports.ReportEntitlementCheckRequestedDocument = exports.ReportEventDocument = exports.ReportUsageDocument = exports.CancelSubscriptionUpdatesDocument = exports.PreviewSubscriptionDocument = exports.EstimateSubscriptionUpdateDocument = void 0;
const graphql_tag_1 = require("graphql-tag");
/** DenyReason of get access policy */
var AccessDeniedReason;
(function (AccessDeniedReason) {
    AccessDeniedReason["CustomerIsArchived"] = "CustomerIsArchived";
    AccessDeniedReason["CustomerNotFound"] = "CustomerNotFound";
    AccessDeniedReason["CustomerResourceNotFound"] = "CustomerResourceNotFound";
    AccessDeniedReason["FeatureNotFound"] = "FeatureNotFound";
    AccessDeniedReason["NoActiveSubscription"] = "NoActiveSubscription";
    AccessDeniedReason["NoFeatureEntitlementInSubscription"] = "NoFeatureEntitlementInSubscription";
    AccessDeniedReason["RequestedUsageExceedingLimit"] = "RequestedUsageExceedingLimit";
    AccessDeniedReason["Unknown"] = "Unknown";
})(AccessDeniedReason = exports.AccessDeniedReason || (exports.AccessDeniedReason = {}));
var AccountStatus;
(function (AccountStatus) {
    AccountStatus["Active"] = "ACTIVE";
    AccountStatus["Blocked"] = "BLOCKED";
})(AccountStatus = exports.AccountStatus || (exports.AccountStatus = {}));
var AddonSortFields;
(function (AddonSortFields) {
    AddonSortFields["BillingId"] = "billingId";
    AddonSortFields["CreatedAt"] = "createdAt";
    AddonSortFields["Description"] = "description";
    AddonSortFields["DisplayName"] = "displayName";
    AddonSortFields["EnvironmentId"] = "environmentId";
    AddonSortFields["Id"] = "id";
    AddonSortFields["IsLatest"] = "isLatest";
    AddonSortFields["PricingType"] = "pricingType";
    AddonSortFields["ProductId"] = "productId";
    AddonSortFields["RefId"] = "refId";
    AddonSortFields["Status"] = "status";
    AddonSortFields["UpdatedAt"] = "updatedAt";
    AddonSortFields["VersionNumber"] = "versionNumber";
})(AddonSortFields = exports.AddonSortFields || (exports.AddonSortFields = {}));
/** Aggregation function */
var AggregationFunction;
(function (AggregationFunction) {
    AggregationFunction["Avg"] = "AVG";
    AggregationFunction["Count"] = "COUNT";
    AggregationFunction["Max"] = "MAX";
    AggregationFunction["Min"] = "MIN";
    AggregationFunction["Sum"] = "SUM";
    AggregationFunction["Unique"] = "UNIQUE";
})(AggregationFunction = exports.AggregationFunction || (exports.AggregationFunction = {}));
/** Alignment */
var Alignment;
(function (Alignment) {
    Alignment["Center"] = "CENTER";
    Alignment["Left"] = "LEFT";
    Alignment["Right"] = "RIGHT";
})(Alignment = exports.Alignment || (exports.Alignment = {}));
var ApiKeySortFields;
(function (ApiKeySortFields) {
    ApiKeySortFields["Id"] = "id";
})(ApiKeySortFields = exports.ApiKeySortFields || (exports.ApiKeySortFields = {}));
var ApiKeyType;
(function (ApiKeyType) {
    ApiKeyType["Client"] = "CLIENT";
    ApiKeyType["Server"] = "SERVER";
})(ApiKeyType = exports.ApiKeyType || (exports.ApiKeyType = {}));
var BillingAnchor;
(function (BillingAnchor) {
    BillingAnchor["StartOfTheMonth"] = "START_OF_THE_MONTH";
    BillingAnchor["SubscriptionStart"] = "SUBSCRIPTION_START";
})(BillingAnchor = exports.BillingAnchor || (exports.BillingAnchor = {}));
/** Billing model. */
var BillingModel;
(function (BillingModel) {
    BillingModel["FlatFee"] = "FLAT_FEE";
    BillingModel["PerUnit"] = "PER_UNIT";
    BillingModel["UsageBased"] = "USAGE_BASED";
})(BillingModel = exports.BillingModel || (exports.BillingModel = {}));
/** Billing period. */
var BillingPeriod;
(function (BillingPeriod) {
    BillingPeriod["Annually"] = "ANNUALLY";
    BillingPeriod["Monthly"] = "MONTHLY";
})(BillingPeriod = exports.BillingPeriod || (exports.BillingPeriod = {}));
/** Billing vendor identifiers */
var BillingVendorIdentifier;
(function (BillingVendorIdentifier) {
    BillingVendorIdentifier["Stripe"] = "STRIPE";
})(BillingVendorIdentifier = exports.BillingVendorIdentifier || (exports.BillingVendorIdentifier = {}));
var ChangeType;
(function (ChangeType) {
    ChangeType["Added"] = "ADDED";
    ChangeType["Deleted"] = "DELETED";
    ChangeType["Modified"] = "MODIFIED";
    ChangeType["Reordered"] = "REORDERED";
})(ChangeType = exports.ChangeType || (exports.ChangeType = {}));
/** Condition operation */
var ConditionOperation;
(function (ConditionOperation) {
    ConditionOperation["Equals"] = "EQUALS";
    ConditionOperation["GreaterThan"] = "GREATER_THAN";
    ConditionOperation["GreaterThanOrEqual"] = "GREATER_THAN_OR_EQUAL";
    ConditionOperation["IsNotNull"] = "IS_NOT_NULL";
    ConditionOperation["IsNull"] = "IS_NULL";
    ConditionOperation["LessThan"] = "LESS_THAN";
    ConditionOperation["LessThanOrEqual"] = "LESS_THAN_OR_EQUAL";
    ConditionOperation["NotEquals"] = "NOT_EQUALS";
})(ConditionOperation = exports.ConditionOperation || (exports.ConditionOperation = {}));
var CouponSortFields;
(function (CouponSortFields) {
    CouponSortFields["BillingId"] = "billingId";
    CouponSortFields["CreatedAt"] = "createdAt";
    CouponSortFields["Description"] = "description";
    CouponSortFields["EnvironmentId"] = "environmentId";
    CouponSortFields["Id"] = "id";
    CouponSortFields["Name"] = "name";
    CouponSortFields["RefId"] = "refId";
    CouponSortFields["Status"] = "status";
    CouponSortFields["Type"] = "type";
    CouponSortFields["UpdatedAt"] = "updatedAt";
})(CouponSortFields = exports.CouponSortFields || (exports.CouponSortFields = {}));
/** The status of the coupon */
var CouponStatus;
(function (CouponStatus) {
    CouponStatus["Active"] = "ACTIVE";
    CouponStatus["Archived"] = "ARCHIVED";
})(CouponStatus = exports.CouponStatus || (exports.CouponStatus = {}));
/** The type of the coupon */
var CouponType;
(function (CouponType) {
    CouponType["Fixed"] = "FIXED";
    CouponType["Percentage"] = "PERCENTAGE";
})(CouponType = exports.CouponType || (exports.CouponType = {}));
/** Currency */
var Currency;
(function (Currency) {
    Currency["Aed"] = "AED";
    Currency["All"] = "ALL";
    Currency["Amd"] = "AMD";
    Currency["Ang"] = "ANG";
    Currency["Aud"] = "AUD";
    Currency["Awg"] = "AWG";
    Currency["Azn"] = "AZN";
    Currency["Bam"] = "BAM";
    Currency["Bbd"] = "BBD";
    Currency["Bdt"] = "BDT";
    Currency["Bgn"] = "BGN";
    Currency["Bif"] = "BIF";
    Currency["Bmd"] = "BMD";
    Currency["Bnd"] = "BND";
    Currency["Bsd"] = "BSD";
    Currency["Bwp"] = "BWP";
    Currency["Byn"] = "BYN";
    Currency["Bzd"] = "BZD";
    Currency["Cad"] = "CAD";
    Currency["Cdf"] = "CDF";
    Currency["Chf"] = "CHF";
    Currency["Clp"] = "CLP";
    Currency["Cny"] = "CNY";
    Currency["Czk"] = "CZK";
    Currency["Djf"] = "DJF";
    Currency["Dkk"] = "DKK";
    Currency["Dop"] = "DOP";
    Currency["Dzd"] = "DZD";
    Currency["Egp"] = "EGP";
    Currency["Etb"] = "ETB";
    Currency["Eur"] = "EUR";
    Currency["Fjd"] = "FJD";
    Currency["Gbp"] = "GBP";
    Currency["Gel"] = "GEL";
    Currency["Gip"] = "GIP";
    Currency["Gmd"] = "GMD";
    Currency["Gnf"] = "GNF";
    Currency["Gyd"] = "GYD";
    Currency["Hkd"] = "HKD";
    Currency["Hrk"] = "HRK";
    Currency["Htg"] = "HTG";
    Currency["Idr"] = "IDR";
    Currency["Ils"] = "ILS";
    Currency["Inr"] = "INR";
    Currency["Isk"] = "ISK";
    Currency["Jmd"] = "JMD";
    Currency["Jpy"] = "JPY";
    Currency["Kes"] = "KES";
    Currency["Kgs"] = "KGS";
    Currency["Khr"] = "KHR";
    Currency["Kmf"] = "KMF";
    Currency["Krw"] = "KRW";
    Currency["Kyd"] = "KYD";
    Currency["Kzt"] = "KZT";
    Currency["Lbp"] = "LBP";
    Currency["Lkr"] = "LKR";
    Currency["Lrd"] = "LRD";
    Currency["Lsl"] = "LSL";
    Currency["Mad"] = "MAD";
    Currency["Mdl"] = "MDL";
    Currency["Mga"] = "MGA";
    Currency["Mkd"] = "MKD";
    Currency["Mmk"] = "MMK";
    Currency["Mnt"] = "MNT";
    Currency["Mop"] = "MOP";
    Currency["Mro"] = "MRO";
    Currency["Mvr"] = "MVR";
    Currency["Mwk"] = "MWK";
    Currency["Mxn"] = "MXN";
    Currency["Myr"] = "MYR";
    Currency["Mzn"] = "MZN";
    Currency["Nad"] = "NAD";
    Currency["Ngn"] = "NGN";
    Currency["Nok"] = "NOK";
    Currency["Npr"] = "NPR";
    Currency["Nzd"] = "NZD";
    Currency["Pgk"] = "PGK";
    Currency["Php"] = "PHP";
    Currency["Pkr"] = "PKR";
    Currency["Pln"] = "PLN";
    Currency["Pyg"] = "PYG";
    Currency["Qar"] = "QAR";
    Currency["Ron"] = "RON";
    Currency["Rsd"] = "RSD";
    Currency["Rub"] = "RUB";
    Currency["Rwf"] = "RWF";
    Currency["Sar"] = "SAR";
    Currency["Sbd"] = "SBD";
    Currency["Scr"] = "SCR";
    Currency["Sek"] = "SEK";
    Currency["Sgd"] = "SGD";
    Currency["Sle"] = "SLE";
    Currency["Sll"] = "SLL";
    Currency["Sos"] = "SOS";
    Currency["Szl"] = "SZL";
    Currency["Thb"] = "THB";
    Currency["Tjs"] = "TJS";
    Currency["Top"] = "TOP";
    Currency["Try"] = "TRY";
    Currency["Ttd"] = "TTD";
    Currency["Tzs"] = "TZS";
    Currency["Uah"] = "UAH";
    Currency["Ugx"] = "UGX";
    Currency["Usd"] = "USD";
    Currency["Uzs"] = "UZS";
    Currency["Vnd"] = "VND";
    Currency["Vuv"] = "VUV";
    Currency["Wst"] = "WST";
    Currency["Xaf"] = "XAF";
    Currency["Xcd"] = "XCD";
    Currency["Xof"] = "XOF";
    Currency["Xpf"] = "XPF";
    Currency["Yer"] = "YER";
    Currency["Zar"] = "ZAR";
    Currency["Zmw"] = "ZMW";
})(Currency = exports.Currency || (exports.Currency = {}));
var CustomerResourceSortFields;
(function (CustomerResourceSortFields) {
    CustomerResourceSortFields["CreatedAt"] = "createdAt";
    CustomerResourceSortFields["EnvironmentId"] = "environmentId";
    CustomerResourceSortFields["ResourceId"] = "resourceId";
})(CustomerResourceSortFields = exports.CustomerResourceSortFields || (exports.CustomerResourceSortFields = {}));
var CustomerSortFields;
(function (CustomerSortFields) {
    CustomerSortFields["BillingId"] = "billingId";
    CustomerSortFields["CreatedAt"] = "createdAt";
    CustomerSortFields["CrmHubspotCompanyId"] = "crmHubspotCompanyId";
    CustomerSortFields["CrmHubspotCompanyUrl"] = "crmHubspotCompanyUrl";
    CustomerSortFields["CrmId"] = "crmId";
    CustomerSortFields["CustomerId"] = "customerId";
    CustomerSortFields["DeletedAt"] = "deletedAt";
    CustomerSortFields["Email"] = "email";
    CustomerSortFields["EnvironmentId"] = "environmentId";
    CustomerSortFields["Id"] = "id";
    CustomerSortFields["Name"] = "name";
    CustomerSortFields["RefId"] = "refId";
    CustomerSortFields["SearchQuery"] = "searchQuery";
    CustomerSortFields["UpdatedAt"] = "updatedAt";
})(CustomerSortFields = exports.CustomerSortFields || (exports.CustomerSortFields = {}));
var CustomerSubscriptionSortFields;
(function (CustomerSubscriptionSortFields) {
    CustomerSubscriptionSortFields["BillingId"] = "billingId";
    CustomerSubscriptionSortFields["CancelReason"] = "cancelReason";
    CustomerSubscriptionSortFields["CancellationDate"] = "cancellationDate";
    CustomerSubscriptionSortFields["CreatedAt"] = "createdAt";
    CustomerSubscriptionSortFields["CrmId"] = "crmId";
    CustomerSubscriptionSortFields["CrmLinkUrl"] = "crmLinkUrl";
    CustomerSubscriptionSortFields["EffectiveEndDate"] = "effectiveEndDate";
    CustomerSubscriptionSortFields["EndDate"] = "endDate";
    CustomerSubscriptionSortFields["EnvironmentId"] = "environmentId";
    CustomerSubscriptionSortFields["Id"] = "id";
    CustomerSubscriptionSortFields["OldBillingId"] = "oldBillingId";
    CustomerSubscriptionSortFields["PaymentCollection"] = "paymentCollection";
    CustomerSubscriptionSortFields["PricingType"] = "pricingType";
    CustomerSubscriptionSortFields["RefId"] = "refId";
    CustomerSubscriptionSortFields["ResourceId"] = "resourceId";
    CustomerSubscriptionSortFields["StartDate"] = "startDate";
    CustomerSubscriptionSortFields["Status"] = "status";
    CustomerSubscriptionSortFields["SubscriptionId"] = "subscriptionId";
    CustomerSubscriptionSortFields["TrialEndDate"] = "trialEndDate";
})(CustomerSubscriptionSortFields = exports.CustomerSubscriptionSortFields || (exports.CustomerSubscriptionSortFields = {}));
var Department;
(function (Department) {
    Department["CeoOrFounder"] = "CEO_OR_FOUNDER";
    Department["Engineering"] = "ENGINEERING";
    Department["Growth"] = "GROWTH";
    Department["Marketing"] = "MARKETING";
    Department["Monetization"] = "MONETIZATION";
    Department["Other"] = "OTHER";
    Department["Product"] = "PRODUCT";
})(Department = exports.Department || (exports.Department = {}));
/** The type of the discount duration */
var DiscountDurationType;
(function (DiscountDurationType) {
    DiscountDurationType["Forever"] = "FOREVER";
    DiscountDurationType["Once"] = "ONCE";
    DiscountDurationType["Repeating"] = "REPEATING";
})(DiscountDurationType = exports.DiscountDurationType || (exports.DiscountDurationType = {}));
/** The type of the discount */
var DiscountType;
(function (DiscountType) {
    DiscountType["Fixed"] = "FIXED";
    DiscountType["Percentage"] = "PERCENTAGE";
})(DiscountType = exports.DiscountType || (exports.DiscountType = {}));
/** Entitlement reset period. */
var EntitlementResetPeriod;
(function (EntitlementResetPeriod) {
    EntitlementResetPeriod["Day"] = "DAY";
    EntitlementResetPeriod["Hour"] = "HOUR";
    EntitlementResetPeriod["Month"] = "MONTH";
    EntitlementResetPeriod["Week"] = "WEEK";
})(EntitlementResetPeriod = exports.EntitlementResetPeriod || (exports.EntitlementResetPeriod = {}));
var EntitySelectionMode;
(function (EntitySelectionMode) {
    EntitySelectionMode["BlackList"] = "BLACK_LIST";
    EntitySelectionMode["WhiteList"] = "WHITE_LIST";
})(EntitySelectionMode = exports.EntitySelectionMode || (exports.EntitySelectionMode = {}));
/** EnvironmentProvisionStatus. */
var EnvironmentProvisionStatus;
(function (EnvironmentProvisionStatus) {
    EnvironmentProvisionStatus["Done"] = "DONE";
    EnvironmentProvisionStatus["Failed"] = "FAILED";
    EnvironmentProvisionStatus["InProgress"] = "IN_PROGRESS";
    EnvironmentProvisionStatus["NotProvisioned"] = "NOT_PROVISIONED";
})(EnvironmentProvisionStatus = exports.EnvironmentProvisionStatus || (exports.EnvironmentProvisionStatus = {}));
var EnvironmentSortFields;
(function (EnvironmentSortFields) {
    EnvironmentSortFields["CreatedAt"] = "createdAt";
    EnvironmentSortFields["DisplayName"] = "displayName";
    EnvironmentSortFields["Id"] = "id";
    EnvironmentSortFields["Slug"] = "slug";
})(EnvironmentSortFields = exports.EnvironmentSortFields || (exports.EnvironmentSortFields = {}));
/** error codes */
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["AccountNotFoundError"] = "AccountNotFoundError";
    ErrorCode["AddonHasToHavePriceError"] = "AddonHasToHavePriceError";
    ErrorCode["AddonNotFound"] = "AddonNotFound";
    ErrorCode["AddonWithDraftCannotBeDeletedError"] = "AddonWithDraftCannotBeDeletedError";
    ErrorCode["ArchivedCouponCantBeApplied"] = "ArchivedCouponCantBeApplied";
    ErrorCode["AuthCustomerMismatch"] = "AuthCustomerMismatch";
    ErrorCode["BadUserInput"] = "BadUserInput";
    ErrorCode["BillingPeriodMissingError"] = "BillingPeriodMissingError";
    ErrorCode["CannotDeleteCustomerError"] = "CannotDeleteCustomerError";
    ErrorCode["CannotDeleteFeatureError"] = "CannotDeleteFeatureError";
    ErrorCode["CannotDeleteProductError"] = "CannotDeleteProductError";
    ErrorCode["CannotEditPackageInNonDraftMode"] = "CannotEditPackageInNonDraftMode";
    ErrorCode["CannotReportUsageForEntitlementWithMeterError"] = "CannotReportUsageForEntitlementWithMeterError";
    ErrorCode["CannotUpsertToPackageThatHasDraft"] = "CannotUpsertToPackageThatHasDraft";
    ErrorCode["CheckoutIsNotSupported"] = "CheckoutIsNotSupported";
    ErrorCode["CheckoutOptionsMissing"] = "CheckoutOptionsMissing";
    ErrorCode["CouponNotFound"] = "CouponNotFound";
    ErrorCode["CustomerAlreadyHaveCustomerCoupon"] = "CustomerAlreadyHaveCustomerCoupon";
    ErrorCode["CustomerAlreadyUsesCoupon"] = "CustomerAlreadyUsesCoupon";
    ErrorCode["CustomerHasNoPaymentMethod"] = "CustomerHasNoPaymentMethod";
    ErrorCode["CustomerNoBillingId"] = "CustomerNoBillingId";
    ErrorCode["CustomerNotFound"] = "CustomerNotFound";
    ErrorCode["CustomerResourceNotFound"] = "CustomerResourceNotFound";
    ErrorCode["DowngradeBillingPeriodNotSupportedError"] = "DowngradeBillingPeriodNotSupportedError";
    ErrorCode["DraftPlanCantBeArchived"] = "DraftPlanCantBeArchived";
    ErrorCode["DuplicatedEntityNotAllowed"] = "DuplicatedEntityNotAllowed";
    ErrorCode["EditAllowedOnDraftPackageOnlyError"] = "EditAllowedOnDraftPackageOnlyError";
    ErrorCode["EntitlementsMustBelongToSamePackage"] = "EntitlementsMustBelongToSamePackage";
    ErrorCode["EntityIdDifferentFromRefIdError"] = "EntityIdDifferentFromRefIdError";
    ErrorCode["EntityIsArchivedError"] = "EntityIsArchivedError";
    ErrorCode["EnvironmentMissing"] = "EnvironmentMissing";
    ErrorCode["ExperimentAlreadyRunning"] = "ExperimentAlreadyRunning";
    ErrorCode["ExperimentNotFoundError"] = "ExperimentNotFoundError";
    ErrorCode["ExperimentStatusError"] = "ExperimentStatusError";
    ErrorCode["FailedToCreateCheckoutSessionError"] = "FailedToCreateCheckoutSessionError";
    ErrorCode["FailedToImportCustomer"] = "FailedToImportCustomer";
    ErrorCode["FeatureNotFound"] = "FeatureNotFound";
    ErrorCode["FetchAllCountriesPricesNotAllowed"] = "FetchAllCountriesPricesNotAllowed";
    ErrorCode["IdentityForbidden"] = "IdentityForbidden";
    ErrorCode["ImportAlreadyInProgress"] = "ImportAlreadyInProgress";
    ErrorCode["ImportSubscriptionsBulkError"] = "ImportSubscriptionsBulkError";
    ErrorCode["InitStripePaymentMethodError"] = "InitStripePaymentMethodError";
    ErrorCode["IntegrationNotFound"] = "IntegrationNotFound";
    ErrorCode["IntegrityViolation"] = "IntegrityViolation";
    ErrorCode["InvalidAddressError"] = "InvalidAddressError";
    ErrorCode["InvalidArgumentError"] = "InvalidArgumentError";
    ErrorCode["InvalidCancellationDate"] = "InvalidCancellationDate";
    ErrorCode["InvalidEntitlementResetPeriod"] = "InvalidEntitlementResetPeriod";
    ErrorCode["InvalidMemberDelete"] = "InvalidMemberDelete";
    ErrorCode["InvalidMetadataError"] = "InvalidMetadataError";
    ErrorCode["InvalidQuantity"] = "InvalidQuantity";
    ErrorCode["InvalidSubscriptionStatus"] = "InvalidSubscriptionStatus";
    ErrorCode["InvalidUpdatePriceUnitAmountError"] = "InvalidUpdatePriceUnitAmountError";
    ErrorCode["MemberInvitationError"] = "MemberInvitationError";
    ErrorCode["MemberNotFound"] = "MemberNotFound";
    ErrorCode["MeterMustBeAssociatedToMeteredFeature"] = "MeterMustBeAssociatedToMeteredFeature";
    ErrorCode["MeteringNotAvailableForFeatureType"] = "MeteringNotAvailableForFeatureType";
    ErrorCode["MissingEntityIdError"] = "MissingEntityIdError";
    ErrorCode["NoFeatureEntitlementInSubscription"] = "NoFeatureEntitlementInSubscription";
    ErrorCode["NoProductsAvailable"] = "NoProductsAvailable";
    ErrorCode["OperationNotAllowedDuringInProgressExperiment"] = "OperationNotAllowedDuringInProgressExperiment";
    ErrorCode["PackageAlreadyPublished"] = "PackageAlreadyPublished";
    ErrorCode["PackagePricingTypeNotSet"] = "PackagePricingTypeNotSet";
    ErrorCode["PaymentMethodNotFoundError"] = "PaymentMethodNotFoundError";
    ErrorCode["PlanAlreadyExtended"] = "PlanAlreadyExtended";
    ErrorCode["PlanCannotBePublishWhenBasePlanIsDraft"] = "PlanCannotBePublishWhenBasePlanIsDraft";
    ErrorCode["PlanIsUsedAsDefaultStartPlan"] = "PlanIsUsedAsDefaultStartPlan";
    ErrorCode["PlanIsUsedAsDowngradePlan"] = "PlanIsUsedAsDowngradePlan";
    ErrorCode["PlanNotFound"] = "PlanNotFound";
    ErrorCode["PlanWithChildCantBeDeleted"] = "PlanWithChildCantBeDeleted";
    ErrorCode["PlansCircularDependencyError"] = "PlansCircularDependencyError";
    ErrorCode["PriceNotFound"] = "PriceNotFound";
    ErrorCode["PromotionCodeCustomerNotFirstPurchase"] = "PromotionCodeCustomerNotFirstPurchase";
    ErrorCode["PromotionCodeMaxRedemptionsReached"] = "PromotionCodeMaxRedemptionsReached";
    ErrorCode["PromotionCodeMinimumAmountNotReached"] = "PromotionCodeMinimumAmountNotReached";
    ErrorCode["PromotionCodeNotActive"] = "PromotionCodeNotActive";
    ErrorCode["PromotionCodeNotForCustomer"] = "PromotionCodeNotForCustomer";
    ErrorCode["PromotionCodeNotFound"] = "PromotionCodeNotFound";
    ErrorCode["PromotionalEntitlementNotFoundError"] = "PromotionalEntitlementNotFoundError";
    ErrorCode["RateLimitExceeded"] = "RateLimitExceeded";
    ErrorCode["RecalculateEntitlementsError"] = "RecalculateEntitlementsError";
    ErrorCode["ResyncAlreadyInProgress"] = "ResyncAlreadyInProgress";
    ErrorCode["ScheduledMigrationAlreadyExistsError"] = "ScheduledMigrationAlreadyExistsError";
    ErrorCode["SelectedBillingModelDoesntMatchImportedItemError"] = "SelectedBillingModelDoesntMatchImportedItemError";
    ErrorCode["StripeCustomerIsDeleted"] = "StripeCustomerIsDeleted";
    ErrorCode["StripeError"] = "StripeError";
    ErrorCode["SubscriptionAlreadyCanceledOrExpired"] = "SubscriptionAlreadyCanceledOrExpired";
    ErrorCode["SubscriptionAlreadyOnLatestPlanError"] = "SubscriptionAlreadyOnLatestPlanError";
    ErrorCode["SubscriptionMustHaveSinglePlanError"] = "SubscriptionMustHaveSinglePlanError";
    ErrorCode["SubscriptionNotFound"] = "SubscriptionNotFound";
    ErrorCode["TooManySubscriptionsPerCustomer"] = "TooManySubscriptionsPerCustomer";
    ErrorCode["TrialMinDateError"] = "TrialMinDateError";
    ErrorCode["TrialMustBeCancelledImmediately"] = "TrialMustBeCancelledImmediately";
    ErrorCode["UnPublishedPackage"] = "UnPublishedPackage";
    ErrorCode["Unauthenticated"] = "Unauthenticated";
    ErrorCode["UncompatibleSubscriptionAddon"] = "UncompatibleSubscriptionAddon";
    ErrorCode["UnexpectedError"] = "UnexpectedError";
    ErrorCode["UnsupportedFeatureType"] = "UnsupportedFeatureType";
    ErrorCode["UnsupportedSubscriptionScheduleType"] = "UnsupportedSubscriptionScheduleType";
    ErrorCode["UnsupportedVendorIdentifier"] = "UnsupportedVendorIdentifier";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
/** EventLogType */
var EventLogType;
(function (EventLogType) {
    EventLogType["AddonCreated"] = "ADDON_CREATED";
    EventLogType["AddonDeleted"] = "ADDON_DELETED";
    EventLogType["AddonUpdated"] = "ADDON_UPDATED";
    EventLogType["CouponArchived"] = "COUPON_ARCHIVED";
    EventLogType["CouponCreated"] = "COUPON_CREATED";
    EventLogType["CouponUpdated"] = "COUPON_UPDATED";
    EventLogType["CreateSubscriptionFailed"] = "CREATE_SUBSCRIPTION_FAILED";
    EventLogType["CustomerCreated"] = "CUSTOMER_CREATED";
    EventLogType["CustomerDeleted"] = "CUSTOMER_DELETED";
    EventLogType["CustomerEntitlementCalculationTriggered"] = "CUSTOMER_ENTITLEMENT_CALCULATION_TRIGGERED";
    EventLogType["CustomerPaymentFailed"] = "CUSTOMER_PAYMENT_FAILED";
    EventLogType["CustomerResourceEntitlementCalculationTriggered"] = "CUSTOMER_RESOURCE_ENTITLEMENT_CALCULATION_TRIGGERED";
    EventLogType["CustomerUpdated"] = "CUSTOMER_UPDATED";
    EventLogType["EdgeApiDataResync"] = "EDGE_API_DATA_RESYNC";
    EventLogType["EntitlementsUpdated"] = "ENTITLEMENTS_UPDATED";
    EventLogType["EntitlementDenied"] = "ENTITLEMENT_DENIED";
    EventLogType["EntitlementGranted"] = "ENTITLEMENT_GRANTED";
    EventLogType["EntitlementRequested"] = "ENTITLEMENT_REQUESTED";
    EventLogType["EnvironmentDeleted"] = "ENVIRONMENT_DELETED";
    EventLogType["FeatureCreated"] = "FEATURE_CREATED";
    EventLogType["FeatureDeleted"] = "FEATURE_DELETED";
    EventLogType["FeatureUpdated"] = "FEATURE_UPDATED";
    EventLogType["ImportIntegrationCatalogTriggered"] = "IMPORT_INTEGRATION_CATALOG_TRIGGERED";
    EventLogType["ImportIntegrationCustomersTriggered"] = "IMPORT_INTEGRATION_CUSTOMERS_TRIGGERED";
    EventLogType["ImportSubscriptionsBulkTriggered"] = "IMPORT_SUBSCRIPTIONS_BULK_TRIGGERED";
    EventLogType["MeasurementReported"] = "MEASUREMENT_REPORTED";
    EventLogType["PackagePublished"] = "PACKAGE_PUBLISHED";
    EventLogType["PlanCreated"] = "PLAN_CREATED";
    EventLogType["PlanDeleted"] = "PLAN_DELETED";
    EventLogType["PlanUpdated"] = "PLAN_UPDATED";
    EventLogType["ProductCreated"] = "PRODUCT_CREATED";
    EventLogType["ProductDeleted"] = "PRODUCT_DELETED";
    EventLogType["ProductUpdated"] = "PRODUCT_UPDATED";
    EventLogType["PromotionalEntitlementExpired"] = "PROMOTIONAL_ENTITLEMENT_EXPIRED";
    EventLogType["PromotionalEntitlementGranted"] = "PROMOTIONAL_ENTITLEMENT_GRANTED";
    EventLogType["PromotionalEntitlementRevoked"] = "PROMOTIONAL_ENTITLEMENT_REVOKED";
    EventLogType["PromotionalEntitlementUpdated"] = "PROMOTIONAL_ENTITLEMENT_UPDATED";
    EventLogType["RecalculateEntitlementsTriggered"] = "RECALCULATE_ENTITLEMENTS_TRIGGERED";
    EventLogType["ResyncIntegrationTriggered"] = "RESYNC_INTEGRATION_TRIGGERED";
    EventLogType["SubscriptionCanceled"] = "SUBSCRIPTION_CANCELED";
    EventLogType["SubscriptionCreated"] = "SUBSCRIPTION_CREATED";
    EventLogType["SubscriptionExpired"] = "SUBSCRIPTION_EXPIRED";
    EventLogType["SubscriptionTrialConverted"] = "SUBSCRIPTION_TRIAL_CONVERTED";
    EventLogType["SubscriptionTrialEndsSoon"] = "SUBSCRIPTION_TRIAL_ENDS_SOON";
    EventLogType["SubscriptionTrialExpired"] = "SUBSCRIPTION_TRIAL_EXPIRED";
    EventLogType["SubscriptionTrialStarted"] = "SUBSCRIPTION_TRIAL_STARTED";
    EventLogType["SubscriptionUpdated"] = "SUBSCRIPTION_UPDATED";
    EventLogType["SubscriptionUsageUpdated"] = "SUBSCRIPTION_USAGE_UPDATED";
    EventLogType["SyncFailed"] = "SYNC_FAILED";
    EventLogType["WidgetConfigurationUpdated"] = "WIDGET_CONFIGURATION_UPDATED";
})(EventLogType = exports.EventLogType || (exports.EventLogType = {}));
var ExperimentSortFields;
(function (ExperimentSortFields) {
    ExperimentSortFields["CreatedAt"] = "createdAt";
    ExperimentSortFields["EnvironmentId"] = "environmentId";
    ExperimentSortFields["Id"] = "id";
    ExperimentSortFields["Name"] = "name";
    ExperimentSortFields["ProductId"] = "productId";
    ExperimentSortFields["RefId"] = "refId";
    ExperimentSortFields["Status"] = "status";
})(ExperimentSortFields = exports.ExperimentSortFields || (exports.ExperimentSortFields = {}));
/** The status of the EXPERIMENT */
var ExperimentStatus;
(function (ExperimentStatus) {
    ExperimentStatus["Completed"] = "COMPLETED";
    ExperimentStatus["Draft"] = "DRAFT";
    ExperimentStatus["InProgress"] = "IN_PROGRESS";
})(ExperimentStatus = exports.ExperimentStatus || (exports.ExperimentStatus = {}));
var FeatureSortFields;
(function (FeatureSortFields) {
    FeatureSortFields["CreatedAt"] = "createdAt";
    FeatureSortFields["Description"] = "description";
    FeatureSortFields["DisplayName"] = "displayName";
    FeatureSortFields["EnvironmentId"] = "environmentId";
    FeatureSortFields["FeatureStatus"] = "featureStatus";
    FeatureSortFields["FeatureType"] = "featureType";
    FeatureSortFields["Id"] = "id";
    FeatureSortFields["MeterType"] = "meterType";
    FeatureSortFields["RefId"] = "refId";
    FeatureSortFields["UpdatedAt"] = "updatedAt";
})(FeatureSortFields = exports.FeatureSortFields || (exports.FeatureSortFields = {}));
/** Feature status. */
var FeatureStatus;
(function (FeatureStatus) {
    FeatureStatus["Active"] = "ACTIVE";
    FeatureStatus["New"] = "NEW";
    FeatureStatus["Suspended"] = "SUSPENDED";
})(FeatureStatus = exports.FeatureStatus || (exports.FeatureStatus = {}));
/** The type of the feature */
var FeatureType;
(function (FeatureType) {
    FeatureType["Boolean"] = "BOOLEAN";
    FeatureType["Number"] = "NUMBER";
})(FeatureType = exports.FeatureType || (exports.FeatureType = {}));
/** Font weight */
var FontWeight;
(function (FontWeight) {
    FontWeight["Bold"] = "BOLD";
    FontWeight["Normal"] = "NORMAL";
})(FontWeight = exports.FontWeight || (exports.FontWeight = {}));
var HookSortFields;
(function (HookSortFields) {
    HookSortFields["CreatedAt"] = "createdAt";
    HookSortFields["Endpoint"] = "endpoint";
    HookSortFields["EnvironmentId"] = "environmentId";
    HookSortFields["Id"] = "id";
    HookSortFields["Status"] = "status";
})(HookSortFields = exports.HookSortFields || (exports.HookSortFields = {}));
/** HookStatus. */
var HookStatus;
(function (HookStatus) {
    HookStatus["Active"] = "ACTIVE";
    HookStatus["Inactive"] = "INACTIVE";
})(HookStatus = exports.HookStatus || (exports.HookStatus = {}));
var ImportIntegrationTaskSortFields;
(function (ImportIntegrationTaskSortFields) {
    ImportIntegrationTaskSortFields["CreatedAt"] = "createdAt";
    ImportIntegrationTaskSortFields["EnvironmentId"] = "environmentId";
    ImportIntegrationTaskSortFields["Id"] = "id";
    ImportIntegrationTaskSortFields["Status"] = "status";
    ImportIntegrationTaskSortFields["TaskType"] = "taskType";
})(ImportIntegrationTaskSortFields = exports.ImportIntegrationTaskSortFields || (exports.ImportIntegrationTaskSortFields = {}));
var IntegrationSortFields;
(function (IntegrationSortFields) {
    IntegrationSortFields["CreatedAt"] = "createdAt";
    IntegrationSortFields["EnvironmentId"] = "environmentId";
    IntegrationSortFields["Id"] = "id";
    IntegrationSortFields["VendorIdentifier"] = "vendorIdentifier";
})(IntegrationSortFields = exports.IntegrationSortFields || (exports.IntegrationSortFields = {}));
var MemberSortFields;
(function (MemberSortFields) {
    MemberSortFields["CreatedAt"] = "createdAt";
    MemberSortFields["Id"] = "id";
})(MemberSortFields = exports.MemberSortFields || (exports.MemberSortFields = {}));
/** Member Status. */
var MemberStatus;
(function (MemberStatus) {
    MemberStatus["Invited"] = "INVITED";
    MemberStatus["Registered"] = "REGISTERED";
})(MemberStatus = exports.MemberStatus || (exports.MemberStatus = {}));
/** The meter type of the feature */
var MeterType;
(function (MeterType) {
    MeterType["Fluctuating"] = "Fluctuating";
    MeterType["Incremental"] = "Incremental";
    MeterType["None"] = "None";
})(MeterType = exports.MeterType || (exports.MeterType = {}));
/** Montly reset period according to configuration */
var MonthlyAccordingTo;
(function (MonthlyAccordingTo) {
    MonthlyAccordingTo["StartOfTheMonth"] = "StartOfTheMonth";
    MonthlyAccordingTo["SubscriptionStart"] = "SubscriptionStart";
})(MonthlyAccordingTo = exports.MonthlyAccordingTo || (exports.MonthlyAccordingTo = {}));
var PackageDtoSortFields;
(function (PackageDtoSortFields) {
    PackageDtoSortFields["BillingId"] = "billingId";
    PackageDtoSortFields["CreatedAt"] = "createdAt";
    PackageDtoSortFields["Description"] = "description";
    PackageDtoSortFields["DisplayName"] = "displayName";
    PackageDtoSortFields["EnvironmentId"] = "environmentId";
    PackageDtoSortFields["Id"] = "id";
    PackageDtoSortFields["IsLatest"] = "isLatest";
    PackageDtoSortFields["PricingType"] = "pricingType";
    PackageDtoSortFields["ProductId"] = "productId";
    PackageDtoSortFields["RefId"] = "refId";
    PackageDtoSortFields["Status"] = "status";
    PackageDtoSortFields["UpdatedAt"] = "updatedAt";
    PackageDtoSortFields["VersionNumber"] = "versionNumber";
})(PackageDtoSortFields = exports.PackageDtoSortFields || (exports.PackageDtoSortFields = {}));
var PackageEntitlementSortFields;
(function (PackageEntitlementSortFields) {
    PackageEntitlementSortFields["CreatedAt"] = "createdAt";
    PackageEntitlementSortFields["EnvironmentId"] = "environmentId";
    PackageEntitlementSortFields["Id"] = "id";
    PackageEntitlementSortFields["PackageId"] = "packageId";
    PackageEntitlementSortFields["UpdatedAt"] = "updatedAt";
})(PackageEntitlementSortFields = exports.PackageEntitlementSortFields || (exports.PackageEntitlementSortFields = {}));
/** Package status. */
var PackageStatus;
(function (PackageStatus) {
    PackageStatus["Archived"] = "ARCHIVED";
    PackageStatus["Draft"] = "DRAFT";
    PackageStatus["Published"] = "PUBLISHED";
})(PackageStatus = exports.PackageStatus || (exports.PackageStatus = {}));
/** Payment collection */
var PaymentCollection;
(function (PaymentCollection) {
    PaymentCollection["ActionRequired"] = "ACTION_REQUIRED";
    PaymentCollection["Failed"] = "FAILED";
    PaymentCollection["NotRequired"] = "NOT_REQUIRED";
    PaymentCollection["Processing"] = "PROCESSING";
})(PaymentCollection = exports.PaymentCollection || (exports.PaymentCollection = {}));
/** Type of a payment method */
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["Bank"] = "BANK";
    PaymentMethodType["Card"] = "CARD";
})(PaymentMethodType = exports.PaymentMethodType || (exports.PaymentMethodType = {}));
var PlanSortFields;
(function (PlanSortFields) {
    PlanSortFields["BillingId"] = "billingId";
    PlanSortFields["CreatedAt"] = "createdAt";
    PlanSortFields["Description"] = "description";
    PlanSortFields["DisplayName"] = "displayName";
    PlanSortFields["EnvironmentId"] = "environmentId";
    PlanSortFields["Id"] = "id";
    PlanSortFields["IsLatest"] = "isLatest";
    PlanSortFields["PricingType"] = "pricingType";
    PlanSortFields["ProductId"] = "productId";
    PlanSortFields["RefId"] = "refId";
    PlanSortFields["Status"] = "status";
    PlanSortFields["UpdatedAt"] = "updatedAt";
    PlanSortFields["VersionNumber"] = "versionNumber";
})(PlanSortFields = exports.PlanSortFields || (exports.PlanSortFields = {}));
var PriceSortFields;
(function (PriceSortFields) {
    PriceSortFields["BillingId"] = "billingId";
    PriceSortFields["BillingModel"] = "billingModel";
    PriceSortFields["BillingPeriod"] = "billingPeriod";
    PriceSortFields["CreatedAt"] = "createdAt";
    PriceSortFields["Id"] = "id";
    PriceSortFields["TiersMode"] = "tiersMode";
})(PriceSortFields = exports.PriceSortFields || (exports.PriceSortFields = {}));
/** Package pricing type. */
var PricingType;
(function (PricingType) {
    PricingType["Custom"] = "CUSTOM";
    PricingType["Free"] = "FREE";
    PricingType["Paid"] = "PAID";
})(PricingType = exports.PricingType || (exports.PricingType = {}));
var ProductSortFields;
(function (ProductSortFields) {
    ProductSortFields["CreatedAt"] = "createdAt";
    ProductSortFields["Description"] = "description";
    ProductSortFields["DisplayName"] = "displayName";
    ProductSortFields["EnvironmentId"] = "environmentId";
    ProductSortFields["Id"] = "id";
    ProductSortFields["IsDefaultProduct"] = "isDefaultProduct";
    ProductSortFields["RefId"] = "refId";
    ProductSortFields["UpdatedAt"] = "updatedAt";
})(ProductSortFields = exports.ProductSortFields || (exports.ProductSortFields = {}));
/** Promotional entitlement duration */
var PromotionalEntitlementPeriod;
(function (PromotionalEntitlementPeriod) {
    PromotionalEntitlementPeriod["Custom"] = "CUSTOM";
    PromotionalEntitlementPeriod["Lifetime"] = "LIFETIME";
    PromotionalEntitlementPeriod["OneMonth"] = "ONE_MONTH";
    PromotionalEntitlementPeriod["OneWeek"] = "ONE_WEEK";
    PromotionalEntitlementPeriod["OneYear"] = "ONE_YEAR";
    PromotionalEntitlementPeriod["SixMonth"] = "SIX_MONTH";
})(PromotionalEntitlementPeriod = exports.PromotionalEntitlementPeriod || (exports.PromotionalEntitlementPeriod = {}));
var PromotionalEntitlementSortFields;
(function (PromotionalEntitlementSortFields) {
    PromotionalEntitlementSortFields["CreatedAt"] = "createdAt";
    PromotionalEntitlementSortFields["EnvironmentId"] = "environmentId";
    PromotionalEntitlementSortFields["Id"] = "id";
    PromotionalEntitlementSortFields["Status"] = "status";
    PromotionalEntitlementSortFields["UpdatedAt"] = "updatedAt";
})(PromotionalEntitlementSortFields = exports.PromotionalEntitlementSortFields || (exports.PromotionalEntitlementSortFields = {}));
/** Promotional entitlement status */
var PromotionalEntitlementStatus;
(function (PromotionalEntitlementStatus) {
    PromotionalEntitlementStatus["Active"] = "Active";
    PromotionalEntitlementStatus["Expired"] = "Expired";
    PromotionalEntitlementStatus["Paused"] = "Paused";
})(PromotionalEntitlementStatus = exports.PromotionalEntitlementStatus || (exports.PromotionalEntitlementStatus = {}));
var ProrationBehavior;
(function (ProrationBehavior) {
    ProrationBehavior["CreateProrations"] = "CREATE_PRORATIONS";
    ProrationBehavior["InvoiceImmediately"] = "INVOICE_IMMEDIATELY";
})(ProrationBehavior = exports.ProrationBehavior || (exports.ProrationBehavior = {}));
/** Provision subscription status */
var ProvisionSubscriptionStatus;
(function (ProvisionSubscriptionStatus) {
    ProvisionSubscriptionStatus["PaymentRequired"] = "PAYMENT_REQUIRED";
    ProvisionSubscriptionStatus["Success"] = "SUCCESS";
})(ProvisionSubscriptionStatus = exports.ProvisionSubscriptionStatus || (exports.ProvisionSubscriptionStatus = {}));
/** PublishMigrationType */
var PublishMigrationType;
(function (PublishMigrationType) {
    PublishMigrationType["AllCustomers"] = "ALL_CUSTOMERS";
    PublishMigrationType["NewCustomers"] = "NEW_CUSTOMERS";
})(PublishMigrationType = exports.PublishMigrationType || (exports.PublishMigrationType = {}));
/** Sort Directions */
var SortDirection;
(function (SortDirection) {
    SortDirection["Asc"] = "ASC";
    SortDirection["Desc"] = "DESC";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));
/** Sort Nulls Options */
var SortNulls;
(function (SortNulls) {
    SortNulls["NullsFirst"] = "NULLS_FIRST";
    SortNulls["NullsLast"] = "NULLS_LAST";
})(SortNulls = exports.SortNulls || (exports.SortNulls = {}));
var SourceType;
(function (SourceType) {
    SourceType["JsClientSdk"] = "JS_CLIENT_SDK";
    SourceType["NodeServerSdk"] = "NODE_SERVER_SDK";
    SourceType["PersistentCacheService"] = "PERSISTENT_CACHE_SERVICE";
})(SourceType = exports.SourceType || (exports.SourceType = {}));
var SubscriptionAddonSortFields;
(function (SubscriptionAddonSortFields) {
    SubscriptionAddonSortFields["CreatedAt"] = "createdAt";
    SubscriptionAddonSortFields["Id"] = "id";
    SubscriptionAddonSortFields["Quantity"] = "quantity";
    SubscriptionAddonSortFields["UpdatedAt"] = "updatedAt";
})(SubscriptionAddonSortFields = exports.SubscriptionAddonSortFields || (exports.SubscriptionAddonSortFields = {}));
/** Subscription cancellation status */
var SubscriptionCancelReason;
(function (SubscriptionCancelReason) {
    SubscriptionCancelReason["CancelledByBilling"] = "CancelledByBilling";
    SubscriptionCancelReason["CustomerArchived"] = "CustomerArchived";
    SubscriptionCancelReason["DetachBilling"] = "DetachBilling";
    SubscriptionCancelReason["Expired"] = "Expired";
    SubscriptionCancelReason["Immediate"] = "Immediate";
    SubscriptionCancelReason["PendingPaymentExpired"] = "PendingPaymentExpired";
    SubscriptionCancelReason["ScheduledCancellation"] = "ScheduledCancellation";
    SubscriptionCancelReason["TrialConverted"] = "TrialConverted";
    SubscriptionCancelReason["TrialEnded"] = "TrialEnded";
    SubscriptionCancelReason["UpgradeOrDowngrade"] = "UpgradeOrDowngrade";
})(SubscriptionCancelReason = exports.SubscriptionCancelReason || (exports.SubscriptionCancelReason = {}));
var SubscriptionCancellationAction;
(function (SubscriptionCancellationAction) {
    SubscriptionCancellationAction["Default"] = "DEFAULT";
    SubscriptionCancellationAction["RevokeEntitlements"] = "REVOKE_ENTITLEMENTS";
})(SubscriptionCancellationAction = exports.SubscriptionCancellationAction || (exports.SubscriptionCancellationAction = {}));
var SubscriptionCancellationTime;
(function (SubscriptionCancellationTime) {
    SubscriptionCancellationTime["EndOfBillingPeriod"] = "END_OF_BILLING_PERIOD";
    SubscriptionCancellationTime["Immediate"] = "IMMEDIATE";
    SubscriptionCancellationTime["SpecificDate"] = "SPECIFIC_DATE";
})(SubscriptionCancellationTime = exports.SubscriptionCancellationTime || (exports.SubscriptionCancellationTime = {}));
/** Subscription decision strategy */
var SubscriptionDecisionStrategy;
(function (SubscriptionDecisionStrategy) {
    SubscriptionDecisionStrategy["PredefinedFreePlan"] = "PREDEFINED_FREE_PLAN";
    SubscriptionDecisionStrategy["PredefinedTrialPlan"] = "PREDEFINED_TRIAL_PLAN";
    SubscriptionDecisionStrategy["RequestedPlan"] = "REQUESTED_PLAN";
    SubscriptionDecisionStrategy["SkippedSubscriptionCreation"] = "SKIPPED_SUBSCRIPTION_CREATION";
})(SubscriptionDecisionStrategy = exports.SubscriptionDecisionStrategy || (exports.SubscriptionDecisionStrategy = {}));
var SubscriptionEndSetup;
(function (SubscriptionEndSetup) {
    SubscriptionEndSetup["CancelSubscription"] = "CANCEL_SUBSCRIPTION";
    SubscriptionEndSetup["DowngradeToFree"] = "DOWNGRADE_TO_FREE";
})(SubscriptionEndSetup = exports.SubscriptionEndSetup || (exports.SubscriptionEndSetup = {}));
var SubscriptionEntitlementSortFields;
(function (SubscriptionEntitlementSortFields) {
    SubscriptionEntitlementSortFields["CreatedAt"] = "createdAt";
    SubscriptionEntitlementSortFields["EnvironmentId"] = "environmentId";
    SubscriptionEntitlementSortFields["Id"] = "id";
    SubscriptionEntitlementSortFields["SubscriptionId"] = "subscriptionId";
    SubscriptionEntitlementSortFields["UpdatedAt"] = "updatedAt";
})(SubscriptionEntitlementSortFields = exports.SubscriptionEntitlementSortFields || (exports.SubscriptionEntitlementSortFields = {}));
/** SubscriptionInvoice status */
var SubscriptionInvoiceStatus;
(function (SubscriptionInvoiceStatus) {
    SubscriptionInvoiceStatus["Canceled"] = "CANCELED";
    SubscriptionInvoiceStatus["Open"] = "OPEN";
    SubscriptionInvoiceStatus["Paid"] = "PAID";
})(SubscriptionInvoiceStatus = exports.SubscriptionInvoiceStatus || (exports.SubscriptionInvoiceStatus = {}));
var SubscriptionMigrationTaskSortFields;
(function (SubscriptionMigrationTaskSortFields) {
    SubscriptionMigrationTaskSortFields["CreatedAt"] = "createdAt";
    SubscriptionMigrationTaskSortFields["EnvironmentId"] = "environmentId";
    SubscriptionMigrationTaskSortFields["Id"] = "id";
    SubscriptionMigrationTaskSortFields["Status"] = "status";
    SubscriptionMigrationTaskSortFields["TaskType"] = "taskType";
})(SubscriptionMigrationTaskSortFields = exports.SubscriptionMigrationTaskSortFields || (exports.SubscriptionMigrationTaskSortFields = {}));
/** Set non immediate cancellation time (atm supported only for stripe integration) */
var SubscriptionMigrationTime;
(function (SubscriptionMigrationTime) {
    SubscriptionMigrationTime["EndOfBillingPeriod"] = "END_OF_BILLING_PERIOD";
    SubscriptionMigrationTime["Immediate"] = "IMMEDIATE";
})(SubscriptionMigrationTime = exports.SubscriptionMigrationTime || (exports.SubscriptionMigrationTime = {}));
var SubscriptionPriceSortFields;
(function (SubscriptionPriceSortFields) {
    SubscriptionPriceSortFields["BillingModel"] = "billingModel";
    SubscriptionPriceSortFields["CreatedAt"] = "createdAt";
    SubscriptionPriceSortFields["FeatureId"] = "featureId";
    SubscriptionPriceSortFields["Id"] = "id";
    SubscriptionPriceSortFields["UpdatedAt"] = "updatedAt";
    SubscriptionPriceSortFields["UsageLimit"] = "usageLimit";
})(SubscriptionPriceSortFields = exports.SubscriptionPriceSortFields || (exports.SubscriptionPriceSortFields = {}));
/** Subscription scheduled schedule status */
var SubscriptionScheduleStatus;
(function (SubscriptionScheduleStatus) {
    SubscriptionScheduleStatus["Canceled"] = "Canceled";
    SubscriptionScheduleStatus["Done"] = "Done";
    SubscriptionScheduleStatus["Failed"] = "Failed";
    SubscriptionScheduleStatus["PendingPayment"] = "PendingPayment";
    SubscriptionScheduleStatus["Scheduled"] = "Scheduled";
})(SubscriptionScheduleStatus = exports.SubscriptionScheduleStatus || (exports.SubscriptionScheduleStatus = {}));
/** Subscription scheduled schedule type */
var SubscriptionScheduleType;
(function (SubscriptionScheduleType) {
    SubscriptionScheduleType["Addon"] = "Addon";
    SubscriptionScheduleType["BillingPeriod"] = "BillingPeriod";
    SubscriptionScheduleType["Downgrade"] = "Downgrade";
    SubscriptionScheduleType["MigrateToLatest"] = "MigrateToLatest";
    SubscriptionScheduleType["UnitAmount"] = "UnitAmount";
})(SubscriptionScheduleType = exports.SubscriptionScheduleType || (exports.SubscriptionScheduleType = {}));
var SubscriptionStartSetup;
(function (SubscriptionStartSetup) {
    SubscriptionStartSetup["FreePlan"] = "FREE_PLAN";
    SubscriptionStartSetup["PlanSelection"] = "PLAN_SELECTION";
    SubscriptionStartSetup["TrialPeriod"] = "TRIAL_PERIOD";
})(SubscriptionStartSetup = exports.SubscriptionStartSetup || (exports.SubscriptionStartSetup = {}));
/** Subscription status */
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["Active"] = "ACTIVE";
    SubscriptionStatus["Canceled"] = "CANCELED";
    SubscriptionStatus["Expired"] = "EXPIRED";
    SubscriptionStatus["InTrial"] = "IN_TRIAL";
    SubscriptionStatus["NotStarted"] = "NOT_STARTED";
    SubscriptionStatus["PaymentPending"] = "PAYMENT_PENDING";
})(SubscriptionStatus = exports.SubscriptionStatus || (exports.SubscriptionStatus = {}));
/** Status of the integration sync */
var SyncStatus;
(function (SyncStatus) {
    SyncStatus["Error"] = "ERROR";
    SyncStatus["NoSyncRequired"] = "NO_SYNC_REQUIRED";
    SyncStatus["Pending"] = "PENDING";
    SyncStatus["Success"] = "SUCCESS";
})(SyncStatus = exports.SyncStatus || (exports.SyncStatus = {}));
var TaskStatus;
(function (TaskStatus) {
    TaskStatus["Completed"] = "COMPLETED";
    TaskStatus["Failed"] = "FAILED";
    TaskStatus["InProgress"] = "IN_PROGRESS";
    TaskStatus["PartiallyFailed"] = "PARTIALLY_FAILED";
    TaskStatus["Pending"] = "PENDING";
})(TaskStatus = exports.TaskStatus || (exports.TaskStatus = {}));
var TaskType;
(function (TaskType) {
    TaskType["ImportIntegrationCatalog"] = "IMPORT_INTEGRATION_CATALOG";
    TaskType["ImportIntegrationCustomers"] = "IMPORT_INTEGRATION_CUSTOMERS";
    TaskType["ImportSubscriptionsBulk"] = "IMPORT_SUBSCRIPTIONS_BULK";
    TaskType["RecalculateEntitlements"] = "RECALCULATE_ENTITLEMENTS";
    TaskType["ResyncIntegration"] = "RESYNC_INTEGRATION";
    TaskType["SubscriptionMigration"] = "SUBSCRIPTION_MIGRATION";
})(TaskType = exports.TaskType || (exports.TaskType = {}));
/** Tiers mode. */
var TiersMode;
(function (TiersMode) {
    TiersMode["Graduated"] = "GRADUATED";
    TiersMode["Volume"] = "VOLUME";
})(TiersMode = exports.TiersMode || (exports.TiersMode = {}));
/** day or month. */
var TrialPeriodUnits;
(function (TrialPeriodUnits) {
    TrialPeriodUnits["Day"] = "DAY";
    TrialPeriodUnits["Month"] = "MONTH";
})(TrialPeriodUnits = exports.TrialPeriodUnits || (exports.TrialPeriodUnits = {}));
var UsageMeasurementSortFields;
(function (UsageMeasurementSortFields) {
    UsageMeasurementSortFields["CreatedAt"] = "createdAt";
    UsageMeasurementSortFields["EnvironmentId"] = "environmentId";
    UsageMeasurementSortFields["Id"] = "id";
})(UsageMeasurementSortFields = exports.UsageMeasurementSortFields || (exports.UsageMeasurementSortFields = {}));
var UsageUpdateBehavior;
(function (UsageUpdateBehavior) {
    UsageUpdateBehavior["Delta"] = "DELTA";
    UsageUpdateBehavior["Set"] = "SET";
})(UsageUpdateBehavior = exports.UsageUpdateBehavior || (exports.UsageUpdateBehavior = {}));
var VendorIdentifier;
(function (VendorIdentifier) {
    VendorIdentifier["Hubspot"] = "HUBSPOT";
    VendorIdentifier["Stripe"] = "STRIPE";
    VendorIdentifier["Zuora"] = "ZUORA";
})(VendorIdentifier = exports.VendorIdentifier || (exports.VendorIdentifier = {}));
/** Weekly reset period according to configuration */
var WeeklyAccordingTo;
(function (WeeklyAccordingTo) {
    WeeklyAccordingTo["EveryFriday"] = "EveryFriday";
    WeeklyAccordingTo["EveryMonday"] = "EveryMonday";
    WeeklyAccordingTo["EverySaturday"] = "EverySaturday";
    WeeklyAccordingTo["EverySunday"] = "EverySunday";
    WeeklyAccordingTo["EveryThursday"] = "EveryThursday";
    WeeklyAccordingTo["EveryTuesday"] = "EveryTuesday";
    WeeklyAccordingTo["EveryWednesday"] = "EveryWednesday";
    WeeklyAccordingTo["SubscriptionStart"] = "SubscriptionStart";
})(WeeklyAccordingTo = exports.WeeklyAccordingTo || (exports.WeeklyAccordingTo = {}));
/** The widget type */
var WidgetType;
(function (WidgetType) {
    WidgetType["Checkout"] = "CHECKOUT";
    WidgetType["CustomerPortal"] = "CUSTOMER_PORTAL";
    WidgetType["Paywall"] = "PAYWALL";
})(WidgetType = exports.WidgetType || (exports.WidgetType = {}));
/** The group of the experiment */
var ExperimentGroupType;
(function (ExperimentGroupType) {
    ExperimentGroupType["Control"] = "CONTROL";
    ExperimentGroupType["Variant"] = "VARIANT";
})(ExperimentGroupType = exports.ExperimentGroupType || (exports.ExperimentGroupType = {}));
exports.SubscriptionInvoiceFragmentDoc = (0, graphql_tag_1.default) `
    fragment SubscriptionInvoiceFragment on SubscriptionInvoice {
  billingId
  status
  createdAt
  updatedAt
  requiresAction
  paymentUrl
  paymentSecret
  errorMessage
}
    `;
exports.CustomerResourceFragmentDoc = (0, graphql_tag_1.default) `
    fragment CustomerResourceFragment on CustomerResource {
  resourceId
}
    `;
exports.PriceTierFragmentDoc = (0, graphql_tag_1.default) `
    fragment PriceTierFragment on PriceTier {
  upTo
  unitPrice {
    amount
    currency
  }
}
    `;
exports.PriceFragmentDoc = (0, graphql_tag_1.default) `
    fragment PriceFragment on Price {
  billingModel
  billingPeriod
  billingId
  minUnitQuantity
  maxUnitQuantity
  billingCountryCode
  price {
    amount
    currency
  }
  tiersMode
  tiers {
    ...PriceTierFragment
  }
  feature {
    refId
    featureUnits
    featureUnitsPlural
    displayName
    description
  }
}
    `;
exports.TotalPriceFragmentDoc = (0, graphql_tag_1.default) `
    fragment TotalPriceFragment on CustomerSubscriptionTotalPrice {
  subTotal {
    amount
    currency
  }
  total {
    amount
    currency
  }
}
    `;
exports.SlimSubscriptionFragmentDoc = (0, graphql_tag_1.default) `
    fragment SlimSubscriptionFragment on CustomerSubscription {
  id
  refId
  status
  additionalMetaData
  billingId
  billingLinkUrl
  effectiveEndDate
  currentBillingPeriodEnd
  pricingType
  latestInvoice {
    ...SubscriptionInvoiceFragment
  }
  paymentCollection
  resource {
    ...CustomerResourceFragment
  }
  experimentInfo {
    name
    id
    groupName
    groupType
  }
  prices {
    usageLimit
    price {
      ...PriceFragment
    }
  }
  totalPrice {
    ...TotalPriceFragment
  }
  plan {
    id
    refId
  }
  addons {
    quantity
    addon {
      id
      refId
    }
  }
  customer {
    id
    refId
  }
}
    `;
exports.SlimCustomerFragmentDoc = (0, graphql_tag_1.default) `
    fragment SlimCustomerFragment on Customer {
  id
  name
  email
  createdAt
  updatedAt
  refId
  billingId
  additionalMetaData
}
    `;
exports.CouponFragmentDoc = (0, graphql_tag_1.default) `
    fragment CouponFragment on Coupon {
  id
  discountValue
  type
  additionalMetaData
  refId
  name
  description
  createdAt
  updatedAt
  billingId
  billingLinkUrl
  status
  syncStates {
    vendorIdentifier
    status
  }
  customers {
    id
  }
}
    `;
exports.PromotionalEntitlementFragmentDoc = (0, graphql_tag_1.default) `
    fragment PromotionalEntitlementFragment on PromotionalEntitlement {
  status
  usageLimit
  featureId
  hasUnlimitedUsage
  resetPeriod
  endDate
  isVisible
  feature {
    featureType
    meterType
    featureUnits
    featureUnitsPlural
    displayName
    description
    refId
    additionalMetaData
  }
}
    `;
exports.CustomerFragmentDoc = (0, graphql_tag_1.default) `
    fragment CustomerFragment on Customer {
  ...SlimCustomerFragment
  hasPaymentMethod
  hasActiveSubscription
  defaultPaymentExpirationMonth
  defaultPaymentExpirationYear
  defaultPaymentMethodLast4Digits
  trialedPlans {
    productId
    productRefId
    planRefId
    planId
  }
  experimentInfo {
    groupType
    groupName
    id
    name
  }
  coupon {
    ...CouponFragment
  }
  eligibleForTrial {
    productId
    productRefId
    eligible
  }
  promotionalEntitlements {
    ...PromotionalEntitlementFragment
  }
}
    `;
exports.ProductFragmentDoc = (0, graphql_tag_1.default) `
    fragment ProductFragment on Product {
  refId
  displayName
  description
  additionalMetaData
  productSettings {
    downgradePlan {
      refId
      displayName
    }
  }
}
    `;
exports.PackageEntitlementFragmentDoc = (0, graphql_tag_1.default) `
    fragment PackageEntitlementFragment on PackageEntitlement {
  usageLimit
  hasUnlimitedUsage
  featureId
  resetPeriod
  hiddenFromWidgets
  isCustom
  displayNameOverride
  feature {
    featureType
    meterType
    featureUnits
    featureUnitsPlural
    displayName
    description
    refId
    additionalMetaData
  }
}
    `;
exports.AddonFragmentDoc = (0, graphql_tag_1.default) `
    fragment AddonFragment on Addon {
  id
  refId
  billingId
  displayName
  description
  additionalMetaData
  entitlements {
    ...PackageEntitlementFragment
  }
  prices {
    ...PriceFragment
  }
  pricingType
}
    `;
exports.PlanFragmentDoc = (0, graphql_tag_1.default) `
    fragment PlanFragment on Plan {
  id
  refId
  displayName
  description
  billingId
  versionNumber
  additionalMetaData
  product {
    ...ProductFragment
  }
  basePlan {
    refId
    displayName
  }
  entitlements {
    ...PackageEntitlementFragment
  }
  inheritedEntitlements {
    ...PackageEntitlementFragment
  }
  compatibleAddons {
    ...AddonFragment
  }
  prices {
    ...PriceFragment
  }
  pricingType
  defaultTrialConfig {
    duration
    units
  }
}
    `;
exports.SubscriptionScheduledUpdateDataFragmentDoc = (0, graphql_tag_1.default) `
    fragment SubscriptionScheduledUpdateData on SubscriptionScheduledUpdate {
  subscriptionScheduleType
  scheduleStatus
  scheduledExecutionTime
  targetPackage {
    id
    refId
    displayName
  }
  scheduleVariables {
    ... on DowngradeChangeVariables {
      addonRefIds
      billingPeriod
      downgradePlanRefId
    }
    ... on BillingPeriodChangeVariables {
      billingPeriod
    }
    ... on UnitAmountChangeVariables {
      newUnitAmount
      featureId
    }
    ... on AddonChangeVariables {
      addonRefId
      newQuantity
    }
  }
}
    `;
exports.SubscriptionFutureUpdateDataFragmentDoc = (0, graphql_tag_1.default) `
    fragment SubscriptionFutureUpdateData on SubscriptionFutureUpdate {
  subscriptionScheduleType
  scheduleStatus
  scheduledExecutionTime
  targetPackage {
    id
    refId
    displayName
  }
  scheduleVariables {
    ... on DowngradeChangeVariables {
      addonRefIds
      billingPeriod
      downgradePlanRefId
    }
    ... on BillingPeriodChangeVariables {
      billingPeriod
    }
    ... on UnitAmountChangeVariables {
      newUnitAmount
      featureId
    }
    ... on AddonChangeVariables {
      addonRefId
      newQuantity
    }
  }
}
    `;
exports.SubscriptionFragmentDoc = (0, graphql_tag_1.default) `
    fragment SubscriptionFragment on CustomerSubscription {
  id
  startDate
  endDate
  trialEndDate
  cancellationDate
  effectiveEndDate
  status
  refId
  currentBillingPeriodEnd
  additionalMetaData
  billingId
  billingLinkUrl
  latestInvoice {
    ...SubscriptionInvoiceFragment
  }
  paymentCollection
  resource {
    ...CustomerResourceFragment
  }
  experimentInfo {
    name
    groupType
    groupName
    id
  }
  prices {
    usageLimit
    price {
      ...PriceFragment
    }
  }
  totalPrice {
    ...TotalPriceFragment
  }
  pricingType
  plan {
    ...PlanFragment
  }
  addons {
    id
    quantity
    addon {
      ...AddonFragment
    }
  }
  scheduledUpdates {
    ...SubscriptionScheduledUpdateData
  }
  futureUpdates {
    ...SubscriptionFutureUpdateData
  }
}
    `;
exports.CustomerWithSubscriptionsFragmentDoc = (0, graphql_tag_1.default) `
    fragment CustomerWithSubscriptionsFragment on Customer {
  ...CustomerFragment
  subscriptions {
    ...SubscriptionFragment
  }
}
    `;
exports.SubscriptionPreviewFragmentDoc = (0, graphql_tag_1.default) `
    fragment SubscriptionPreviewFragment on SubscriptionPreview {
  subTotal {
    amount
    currency
  }
  totalExcludingTax {
    amount
    currency
  }
  total {
    amount
    currency
  }
  discountAmount {
    amount
    currency
  }
  taxDetails {
    displayName
    percentage
    inclusive
  }
  tax {
    amount
    currency
  }
  billingPeriodRange {
    start
    end
  }
  discount {
    type
    value
    durationType
    durationInMonths
  }
  subscription {
    subTotal {
      amount
      currency
    }
    totalExcludingTax {
      amount
      currency
    }
    total {
      amount
      currency
    }
    tax {
      amount
      currency
    }
    discountAmount {
      amount
      currency
    }
    taxDetails {
      displayName
      percentage
      inclusive
    }
    discount {
      type
      value
      durationType
      durationInMonths
    }
  }
  proration {
    prorationDate
    credit {
      amount
      currency
    }
    debit {
      amount
      currency
    }
    netAmount {
      amount
      currency
    }
  }
  isPlanDowngrade
  hasScheduledUpdates
  credits {
    initial {
      amount
      currency
    }
    used {
      amount
      currency
    }
    remaining {
      amount
      currency
    }
  }
}
    `;
exports.ImmediateSubscriptionPreviewInvoiceFragmentDoc = (0, graphql_tag_1.default) `
    fragment ImmediateSubscriptionPreviewInvoiceFragment on ImmediateSubscriptionPreviewInvoice {
  total {
    amount
    currency
  }
  subTotal {
    amount
    currency
  }
  totalExcludingTax {
    amount
    currency
  }
  tax {
    amount
    currency
  }
  discount {
    amount
    currency
  }
  taxDetails {
    displayName
    percentage
    inclusive
  }
  discountDetails {
    type
    value
    durationType
    durationInMonths
  }
  credits {
    initial {
      amount
      currency
    }
    used {
      amount
      currency
    }
    remaining {
      amount
      currency
    }
  }
  proration {
    prorationDate
    hasProrations
    credit {
      amount
      currency
    }
    debit {
      amount
      currency
    }
    netAmount {
      amount
      currency
    }
  }
}
    `;
exports.SubscriptionPreviewInvoiceFragmentDoc = (0, graphql_tag_1.default) `
    fragment SubscriptionPreviewInvoiceFragment on SubscriptionPreviewInvoice {
  total {
    amount
    currency
  }
  subTotal {
    amount
    currency
  }
  totalExcludingTax {
    amount
    currency
  }
  tax {
    amount
    currency
  }
  discount {
    amount
    currency
  }
  taxDetails {
    displayName
    percentage
    inclusive
  }
  discountDetails {
    type
    value
    durationType
    durationInMonths
  }
}
    `;
exports.SubscriptionPreviewV2FragmentDoc = (0, graphql_tag_1.default) `
    fragment SubscriptionPreviewV2Fragment on SubscriptionPreviewV2 {
  immediateInvoice {
    ...ImmediateSubscriptionPreviewInvoiceFragment
  }
  recurringInvoice {
    ...SubscriptionPreviewInvoiceFragment
  }
  billingPeriodRange {
    start
    end
  }
  isPlanDowngrade
  hasScheduledUpdates
}
    `;
exports.ResetPeriodConfigurationFragmentDoc = (0, graphql_tag_1.default) `
    fragment ResetPeriodConfigurationFragment on ResetPeriodConfiguration {
  __typename
  ... on MonthlyResetPeriodConfig {
    monthlyAccordingTo
  }
  ... on WeeklyResetPeriodConfig {
    weeklyAccordingTo
  }
}
    `;
exports.FeatureFragmentDoc = (0, graphql_tag_1.default) `
    fragment FeatureFragment on EntitlementFeature {
  featureType
  meterType
  featureUnits
  featureUnitsPlural
  description
  displayName
  refId
}
    `;
exports.EntitlementFragmentDoc = (0, graphql_tag_1.default) `
    fragment EntitlementFragment on Entitlement {
  isGranted
  accessDeniedReason
  customerId
  resourceId
  usageLimit
  hasUnlimitedUsage
  currentUsage
  requestedUsage
  entitlementUpdatedAt
  usageUpdatedAt
  nextResetDate
  resetPeriod
  resetPeriodConfiguration {
    ...ResetPeriodConfigurationFragment
  }
  feature {
    ...FeatureFragment
  }
}
    `;
exports.EntitlementsUpdatedPayloadFragmentDoc = (0, graphql_tag_1.default) `
    fragment EntitlementsUpdatedPayload on EntitlementsUpdated {
  customerId
  resourceId
  entitlements {
    ...EntitlementFragment
  }
}
    `;
exports.UsageUpdatedFragmentDoc = (0, graphql_tag_1.default) `
    fragment UsageUpdatedFragment on UsageMeasurementUpdated {
  customerId
  resourceId
  featureId
  currentUsage
  nextResetDate
}
    `;
exports.EntitlementUsageUpdatedFragmentDoc = (0, graphql_tag_1.default) `
    fragment EntitlementUsageUpdated on UsageUpdated {
  usage {
    ...UsageUpdatedFragment
  }
  entitlement {
    ...EntitlementFragment
  }
}
    `;
exports.CustomerPortalSubscriptionPriceFragmentDoc = (0, graphql_tag_1.default) `
    fragment CustomerPortalSubscriptionPriceFragment on CustomerPortalSubscriptionPrice {
  billingPeriod
  billingModel
  price {
    amount
    currency
  }
  feature {
    id
    refId
    displayName
    featureUnits
    featureUnitsPlural
  }
}
    `;
exports.CustomerPortalSubscriptionAddonFragmentDoc = (0, graphql_tag_1.default) `
    fragment CustomerPortalSubscriptionAddonFragment on CustomerPortalAddon {
  addonId
  description
  displayName
  quantity
}
    `;
exports.CustomerPortalSubscriptionScheduledUpdateDataFragmentDoc = (0, graphql_tag_1.default) `
    fragment CustomerPortalSubscriptionScheduledUpdateDataFragment on SubscriptionScheduledUpdate {
  subscriptionScheduleType
  scheduleStatus
  scheduledExecutionTime
  targetPackage {
    id
    refId
    displayName
    pricingType
  }
  scheduleVariables {
    ... on DowngradeChangeVariables {
      addonRefIds
      billingPeriod
      downgradePlanRefId
    }
    ... on BillingPeriodChangeVariables {
      billingPeriod
    }
    ... on UnitAmountChangeVariables {
      newUnitAmount
      featureId
    }
    ... on AddonChangeVariables {
      addonRefId
      newQuantity
    }
  }
}
    `;
exports.CustomerPortalSubscriptionFragmentDoc = (0, graphql_tag_1.default) `
    fragment CustomerPortalSubscriptionFragment on CustomerPortalSubscription {
  subscriptionId
  planName
  pricingType
  prices {
    ...CustomerPortalSubscriptionPriceFragment
  }
  pricing {
    unitQuantity
    billingPeriod
    billingModel
    pricingType
    usageBasedEstimatedBill
    price {
      amount
      currency
    }
    feature {
      featureUnits
      featureUnitsPlural
      displayName
    }
  }
  status
  trialRemainingDays
  billingPeriodRange {
    start
    end
  }
  totalPrice {
    subTotal {
      amount
      currency
    }
    total {
      amount
      currency
    }
    addonsTotal {
      amount
      currency
    }
  }
  addons {
    ...CustomerPortalSubscriptionAddonFragment
  }
  scheduledUpdates {
    ...CustomerPortalSubscriptionScheduledUpdateDataFragment
  }
}
    `;
exports.CustomerPortalEntitlementFragmentDoc = (0, graphql_tag_1.default) `
    fragment CustomerPortalEntitlementFragment on Entitlement {
  isGranted
  usageLimit
  currentUsage
  hasUnlimitedUsage
  nextResetDate
  resetPeriod
  resetPeriodConfiguration {
    ...ResetPeriodConfigurationFragment
  }
  feature {
    ...FeatureFragment
  }
}
    `;
exports.CustomerPortalPromotionalEntitlementFragmentDoc = (0, graphql_tag_1.default) `
    fragment CustomerPortalPromotionalEntitlementFragment on CustomerPortalPromotionalEntitlement {
  displayName
  hasUnlimitedUsage
  usageLimit
  period
  startDate
  endDate
}
    `;
exports.CustomerPortalBillingInformationFragmentDoc = (0, graphql_tag_1.default) `
    fragment CustomerPortalBillingInformationFragment on CustomerPortalBillingInformation {
  email
  name
  defaultPaymentMethodLast4Digits
  defaultPaymentMethodId
  defaultPaymentExpirationMonth
  defaultPaymentExpirationYear
}
    `;
exports.FontVariantFragmentDoc = (0, graphql_tag_1.default) `
    fragment FontVariantFragment on FontVariant {
  fontSize
  fontWeight
}
    `;
exports.TypographyConfigurationFragmentDoc = (0, graphql_tag_1.default) `
    fragment TypographyConfigurationFragment on TypographyConfiguration {
  fontFamily
  h1 {
    ...FontVariantFragment
  }
  h2 {
    ...FontVariantFragment
  }
  h3 {
    ...FontVariantFragment
  }
  body {
    ...FontVariantFragment
  }
}
    `;
exports.CustomerPortalConfigurationFragmentDoc = (0, graphql_tag_1.default) `
    fragment CustomerPortalConfigurationFragment on CustomerPortalConfiguration {
  palette {
    primary
    textColor
    backgroundColor
    borderColor
    currentPlanBackground
    iconsColor
    paywallBackgroundColor
  }
  typography {
    ...TypographyConfigurationFragment
  }
  customCss
}
    `;
exports.CustomerPortalFragmentDoc = (0, graphql_tag_1.default) `
    fragment CustomerPortalFragment on CustomerPortal {
  subscriptions {
    ...CustomerPortalSubscriptionFragment
  }
  entitlements {
    ...CustomerPortalEntitlementFragment
  }
  promotionalEntitlements {
    ...CustomerPortalPromotionalEntitlementFragment
  }
  billingInformation {
    ...CustomerPortalBillingInformationFragment
  }
  showWatermark
  billingPortalUrl
  canUpgradeSubscription
  configuration {
    ...CustomerPortalConfigurationFragment
  }
  resource {
    ...CustomerResourceFragment
  }
}
    `;
exports.CheckoutConfigurationFragmentDoc = (0, graphql_tag_1.default) `
    fragment CheckoutConfigurationFragment on CheckoutConfiguration {
  palette {
    primary
    textColor
    backgroundColor
    borderColor
    summaryBackgroundColor
    __typename
  }
  typography {
    ...TypographyConfigurationFragment
    __typename
  }
  customCss
  content {
    collectPhoneNumber
  }
  __typename
}
    `;
exports.CheckoutStateFragmentDoc = (0, graphql_tag_1.default) `
    fragment CheckoutStateFragment on CheckoutState {
  configuration {
    ...CheckoutConfigurationFragment
  }
  setupSecret
  customer {
    ...CustomerFragment
  }
  activeSubscription {
    ...SubscriptionFragment
  }
  resource {
    ...CustomerResourceFragment
  }
  plan {
    ...PlanFragment
  }
  billingIntegration {
    billingIdentifier
    credentials {
      accountId
      publicKey
    }
  }
}
    `;
exports.MockPaywallPackageEntitlementFragmentDoc = (0, graphql_tag_1.default) `
    fragment MockPaywallPackageEntitlementFragment on Entitlement {
  usageLimit
  hasUnlimitedUsage
  resetPeriod
  hiddenFromWidgets
  displayNameOverride
  feature {
    featureType
    meterType
    featureUnits
    featureUnitsPlural
    displayName
    description
    refId
    additionalMetaData
  }
}
    `;
exports.MockPaywallPriceFragmentDoc = (0, graphql_tag_1.default) `
    fragment MockPaywallPriceFragment on PaywallPrice {
  billingModel
  billingPeriod
  billingId
  minUnitQuantity
  maxUnitQuantity
  billingCountryCode
  price {
    amount
    currency
  }
  tiersMode
  tiers {
    ...PriceTierFragment
  }
  feature {
    refId
    featureUnits
    featureUnitsPlural
    displayName
  }
}
    `;
exports.MockPaywallAddonFragmentDoc = (0, graphql_tag_1.default) `
    fragment MockPaywallAddonFragment on PaywallAddon {
  refId
  displayName
  description
  additionalMetaData
  billingId
  entitlements {
    ...MockPaywallPackageEntitlementFragment
  }
  prices {
    ...MockPaywallPriceFragment
  }
  pricingType
}
    `;
exports.MockPaywallPlanFragmentDoc = (0, graphql_tag_1.default) `
    fragment MockPaywallPlanFragment on PaywallPlan {
  refId
  description
  displayName
  billingId
  additionalMetaData
  product {
    refId
    displayName
    description
    additionalMetaData
  }
  basePlan {
    refId
    displayName
  }
  entitlements {
    ...MockPaywallPackageEntitlementFragment
  }
  inheritedEntitlements {
    ...MockPaywallPackageEntitlementFragment
  }
  prices {
    ...MockPaywallPriceFragment
  }
  pricingType
  defaultTrialConfig {
    duration
    units
  }
  compatibleAddons {
    ...MockPaywallAddonFragment
  }
}
    `;
exports.PaywallCurrencyFragmentDoc = (0, graphql_tag_1.default) `
    fragment PaywallCurrencyFragment on PaywallCurrency {
  code
  symbol
}
    `;
exports.LayoutConfigurationFragmentDoc = (0, graphql_tag_1.default) `
    fragment LayoutConfigurationFragment on PaywallLayoutConfiguration {
  alignment
  planWidth
  planMargin
  planPadding
}
    `;
exports.PaywallConfigurationFragmentDoc = (0, graphql_tag_1.default) `
    fragment PaywallConfigurationFragment on PaywallConfiguration {
  palette {
    primary
    textColor
    backgroundColor
    borderColor
    currentPlanBackground
  }
  typography {
    ...TypographyConfigurationFragment
  }
  layout {
    ...LayoutConfigurationFragment
  }
  customCss
}
    `;
exports.PaywallCalculatedPricePointsFragmentDoc = (0, graphql_tag_1.default) `
    fragment PaywallCalculatedPricePointsFragment on PaywallPricePoint {
  planId
  additionalChargesMayApply
  billingPeriod
  amount
  currency
  billingCountryCode
  feature {
    refId
    featureUnits
    featureUnitsPlural
    displayName
    description
  }
}
    `;
exports.PaywallFragmentDoc = (0, graphql_tag_1.default) `
    fragment PaywallFragment on Paywall {
  plans {
    ...PlanFragment
  }
  currency {
    ...PaywallCurrencyFragment
  }
  configuration {
    ...PaywallConfigurationFragment
  }
  customer {
    ...CustomerFragment
  }
  activeSubscriptions {
    ...SubscriptionFragment
  }
  resource {
    ...CustomerResourceFragment
  }
  paywallCalculatedPricePoints {
    ...PaywallCalculatedPricePointsFragment
  }
}
    `;
exports.UsageHistoryFragmentDoc = (0, graphql_tag_1.default) `
    fragment UsageHistoryFragment on UsageHistory {
  startDate
  endDate
  usageMeasurements {
    date
    value
    isResetPoint
  }
}
    `;
exports.ProvisionCustomerDocument = (0, graphql_tag_1.default) `
    mutation ProvisionCustomer($input: ProvisionCustomerInput!) {
  provisionCustomer(input: $input) {
    customer {
      ...SlimCustomerFragment
    }
    subscriptionDecisionStrategy
    subscription {
      ...SlimSubscriptionFragment
    }
  }
}
    ${exports.SlimCustomerFragmentDoc}
${exports.SlimSubscriptionFragmentDoc}
${exports.SubscriptionInvoiceFragmentDoc}
${exports.CustomerResourceFragmentDoc}
${exports.PriceFragmentDoc}
${exports.PriceTierFragmentDoc}
${exports.TotalPriceFragmentDoc}`;
exports.ImportCustomerBulkDocument = (0, graphql_tag_1.default) `
    mutation ImportCustomerBulk($input: ImportCustomerBulk!) {
  importCustomersBulk(input: $input)
}
    `;
exports.ImportCustomerDocument = (0, graphql_tag_1.default) `
    mutation ImportCustomer($input: ImportCustomerInput!) {
  importCustomer: importOneCustomer(input: $input) {
    ...SlimCustomerFragment
  }
}
    ${exports.SlimCustomerFragmentDoc}`;
exports.UpdateCustomerDocument = (0, graphql_tag_1.default) `
    mutation UpdateCustomer($input: UpdateCustomerInput!) {
  updateCustomer: updateOneCustomer(input: $input) {
    ...SlimCustomerFragment
  }
}
    ${exports.SlimCustomerFragmentDoc}`;
exports.GrantPromotionalEntitlementsDocument = (0, graphql_tag_1.default) `
    mutation GrantPromotionalEntitlements($input: GrantPromotionalEntitlementsInput!) {
  grantPromotionalEntitlements(input: $input) {
    ...PromotionalEntitlementFragment
  }
}
    ${exports.PromotionalEntitlementFragmentDoc}`;
exports.RevokePromotionalEntitlementDocument = (0, graphql_tag_1.default) `
    mutation RevokePromotionalEntitlement($input: RevokePromotionalEntitlementInput!) {
  revokePromotionalEntitlement(input: $input) {
    id
  }
}
    `;
exports.ProvisionSubscriptionDocument = (0, graphql_tag_1.default) `
    mutation ProvisionSubscription($input: ProvisionSubscriptionInput!) {
  provisionSubscription: provisionSubscriptionV2(input: $input) {
    checkoutUrl
    status
    subscription {
      ...SlimSubscriptionFragment
    }
  }
}
    ${exports.SlimSubscriptionFragmentDoc}
${exports.SubscriptionInvoiceFragmentDoc}
${exports.CustomerResourceFragmentDoc}
${exports.PriceFragmentDoc}
${exports.PriceTierFragmentDoc}
${exports.TotalPriceFragmentDoc}`;
exports.ApplySubscriptionDocument = (0, graphql_tag_1.default) `
    mutation ApplySubscription($input: ApplySubscriptionInput!) {
  applySubscription(input: $input) {
    subscription {
      ...SubscriptionFragment
    }
  }
}
    ${exports.SubscriptionFragmentDoc}
${exports.SubscriptionInvoiceFragmentDoc}
${exports.CustomerResourceFragmentDoc}
${exports.PriceFragmentDoc}
${exports.PriceTierFragmentDoc}
${exports.TotalPriceFragmentDoc}
${exports.PlanFragmentDoc}
${exports.ProductFragmentDoc}
${exports.PackageEntitlementFragmentDoc}
${exports.AddonFragmentDoc}
${exports.SubscriptionScheduledUpdateDataFragmentDoc}
${exports.SubscriptionFutureUpdateDataFragmentDoc}`;
exports.ImportSubscriptionsBulkDocument = (0, graphql_tag_1.default) `
    mutation ImportSubscriptionsBulk($input: ImportSubscriptionsBulk!) {
  importSubscriptionsBulk(input: $input)
}
    `;
exports.UpdateSubscriptionDocument = (0, graphql_tag_1.default) `
    mutation UpdateSubscription($input: UpdateSubscriptionInput!) {
  updateSubscription: updateOneSubscription(input: $input) {
    ...SlimSubscriptionFragment
  }
}
    ${exports.SlimSubscriptionFragmentDoc}
${exports.SubscriptionInvoiceFragmentDoc}
${exports.CustomerResourceFragmentDoc}
${exports.PriceFragmentDoc}
${exports.PriceTierFragmentDoc}
${exports.TotalPriceFragmentDoc}`;
exports.CancelSubscriptionDocument = (0, graphql_tag_1.default) `
    mutation CancelSubscription($input: SubscriptionCancellationInput!) {
  cancelSubscription(input: $input) {
    ...SlimSubscriptionFragment
  }
}
    ${exports.SlimSubscriptionFragmentDoc}
${exports.SubscriptionInvoiceFragmentDoc}
${exports.CustomerResourceFragmentDoc}
${exports.PriceFragmentDoc}
${exports.PriceTierFragmentDoc}
${exports.TotalPriceFragmentDoc}`;
exports.EstimateSubscriptionDocument = (0, graphql_tag_1.default) `
    mutation EstimateSubscription($input: EstimateSubscriptionInput!) {
  estimateSubscription(input: $input) {
    ...SubscriptionPreviewFragment
  }
}
    ${exports.SubscriptionPreviewFragmentDoc}`;
exports.EstimateSubscriptionUpdateDocument = (0, graphql_tag_1.default) `
    mutation EstimateSubscriptionUpdate($input: EstimateSubscriptionUpdateInput!) {
  estimateSubscriptionUpdate(input: $input) {
    ...SubscriptionPreviewFragment
  }
}
    ${exports.SubscriptionPreviewFragmentDoc}`;
exports.PreviewSubscriptionDocument = (0, graphql_tag_1.default) `
    mutation PreviewSubscription($input: PreviewSubscriptionInput!) {
  previewSubscription(input: $input) {
    ...SubscriptionPreviewV2Fragment
  }
}
    ${exports.SubscriptionPreviewV2FragmentDoc}
${exports.ImmediateSubscriptionPreviewInvoiceFragmentDoc}
${exports.SubscriptionPreviewInvoiceFragmentDoc}`;
exports.CancelSubscriptionUpdatesDocument = (0, graphql_tag_1.default) `
    mutation CancelSubscriptionUpdates($input: SubscriptionUpdateScheduleCancellationInput!) {
  cancelSchedule(input: $input)
}
    `;
exports.ReportUsageDocument = (0, graphql_tag_1.default) `
    mutation ReportUsage($input: UsageMeasurementCreateInput!) {
  createUsageMeasurement(usageMeasurement: $input) {
    id
    currentUsage
    nextResetDate
    timestamp
  }
}
    `;
exports.ReportEventDocument = (0, graphql_tag_1.default) `
    mutation ReportEvent($input: UsageEventsReportInput!) {
  reportEvent(events: $input)
}
    `;
exports.ReportEntitlementCheckRequestedDocument = (0, graphql_tag_1.default) `
    mutation ReportEntitlementCheckRequested($entitlementCheckRequested: EntitlementCheckRequested!) {
  reportEntitlementCheckRequested(
    entitlementCheckRequested: $entitlementCheckRequested
  )
}
    `;
exports.CreateSubscriptionDocument = (0, graphql_tag_1.default) `
    mutation CreateSubscription($input: SubscriptionInput!) {
  createSubscription(subscription: $input) {
    ...SlimSubscriptionFragment
  }
}
    ${exports.SlimSubscriptionFragmentDoc}
${exports.SubscriptionInvoiceFragmentDoc}
${exports.CustomerResourceFragmentDoc}
${exports.PriceFragmentDoc}
${exports.PriceTierFragmentDoc}
${exports.TotalPriceFragmentDoc}`;
exports.MigrateSubscriptionToLatestDocument = (0, graphql_tag_1.default) `
    mutation MigrateSubscriptionToLatest($input: SubscriptionMigrationInput!) {
  migrateSubscriptionToLatest(input: $input) {
    subscriptionId
  }
}
    `;
exports.ArchiveCustomerDocument = (0, graphql_tag_1.default) `
    mutation ArchiveCustomer($input: ArchiveCustomerInput!) {
  archiveCustomer(input: $input) {
    customerId
  }
}
    `;
exports.TransferSubscriptionDocument = (0, graphql_tag_1.default) `
    mutation TransferSubscription($input: TransferSubscriptionInput!) {
  transferSubscription(input: $input) {
    ...SlimSubscriptionFragment
  }
}
    ${exports.SlimSubscriptionFragmentDoc}
${exports.SubscriptionInvoiceFragmentDoc}
${exports.CustomerResourceFragmentDoc}
${exports.PriceFragmentDoc}
${exports.PriceTierFragmentDoc}
${exports.TotalPriceFragmentDoc}`;
exports.GetCustomerByIdDocument = (0, graphql_tag_1.default) `
    query GetCustomerById($input: GetCustomerByRefIdInput!) {
  getCustomerByRefId(input: $input) {
    ...CustomerWithSubscriptionsFragment
  }
}
    ${exports.CustomerWithSubscriptionsFragmentDoc}
${exports.CustomerFragmentDoc}
${exports.SlimCustomerFragmentDoc}
${exports.CouponFragmentDoc}
${exports.PromotionalEntitlementFragmentDoc}
${exports.SubscriptionFragmentDoc}
${exports.SubscriptionInvoiceFragmentDoc}
${exports.CustomerResourceFragmentDoc}
${exports.PriceFragmentDoc}
${exports.PriceTierFragmentDoc}
${exports.TotalPriceFragmentDoc}
${exports.PlanFragmentDoc}
${exports.ProductFragmentDoc}
${exports.PackageEntitlementFragmentDoc}
${exports.AddonFragmentDoc}
${exports.SubscriptionScheduledUpdateDataFragmentDoc}
${exports.SubscriptionFutureUpdateDataFragmentDoc}`;
exports.GetActiveSubscriptionsDocument = (0, graphql_tag_1.default) `
    query GetActiveSubscriptions($input: GetActiveSubscriptionsInput!) {
  getActiveSubscriptions(input: $input) {
    ...SubscriptionFragment
  }
}
    ${exports.SubscriptionFragmentDoc}
${exports.SubscriptionInvoiceFragmentDoc}
${exports.CustomerResourceFragmentDoc}
${exports.PriceFragmentDoc}
${exports.PriceTierFragmentDoc}
${exports.TotalPriceFragmentDoc}
${exports.PlanFragmentDoc}
${exports.ProductFragmentDoc}
${exports.PackageEntitlementFragmentDoc}
${exports.AddonFragmentDoc}
${exports.SubscriptionScheduledUpdateDataFragmentDoc}
${exports.SubscriptionFutureUpdateDataFragmentDoc}`;
exports.GetCouponsDocument = (0, graphql_tag_1.default) `
    query GetCoupons {
  coupons(filter: {status: {eq: ACTIVE}}, paging: {first: 50}) {
    edges {
      node {
        ...CouponFragment
      }
    }
  }
}
    ${exports.CouponFragmentDoc}`;
exports.GetPaywallDocument = (0, graphql_tag_1.default) `
    query GetPaywall($input: GetPaywallInput!) {
  paywall(input: $input) {
    ...PaywallFragment
  }
}
    ${exports.PaywallFragmentDoc}
${exports.PlanFragmentDoc}
${exports.ProductFragmentDoc}
${exports.PackageEntitlementFragmentDoc}
${exports.AddonFragmentDoc}
${exports.PriceFragmentDoc}
${exports.PriceTierFragmentDoc}
${exports.PaywallCurrencyFragmentDoc}
${exports.PaywallConfigurationFragmentDoc}
${exports.TypographyConfigurationFragmentDoc}
${exports.FontVariantFragmentDoc}
${exports.LayoutConfigurationFragmentDoc}
${exports.CustomerFragmentDoc}
${exports.SlimCustomerFragmentDoc}
${exports.CouponFragmentDoc}
${exports.PromotionalEntitlementFragmentDoc}
${exports.SubscriptionFragmentDoc}
${exports.SubscriptionInvoiceFragmentDoc}
${exports.CustomerResourceFragmentDoc}
${exports.TotalPriceFragmentDoc}
${exports.SubscriptionScheduledUpdateDataFragmentDoc}
${exports.SubscriptionFutureUpdateDataFragmentDoc}
${exports.PaywallCalculatedPricePointsFragmentDoc}`;
exports.GetEntitlementsDocument = (0, graphql_tag_1.default) `
    query GetEntitlements($query: FetchEntitlementsQuery!) {
  entitlements: cachedEntitlements(query: $query) {
    ...EntitlementFragment
  }
}
    ${exports.EntitlementFragmentDoc}
${exports.ResetPeriodConfigurationFragmentDoc}
${exports.FeatureFragmentDoc}`;
exports.GetEntitlementDocument = (0, graphql_tag_1.default) `
    query GetEntitlement($query: FetchEntitlementQuery!) {
  entitlement(query: $query) {
    ...EntitlementFragment
  }
}
    ${exports.EntitlementFragmentDoc}
${exports.ResetPeriodConfigurationFragmentDoc}
${exports.FeatureFragmentDoc}`;
exports.GetProductsDocument = (0, graphql_tag_1.default) `
    query GetProducts {
  products(paging: {first: 50}) {
    edges {
      node {
        ...ProductFragment
      }
    }
  }
}
    ${exports.ProductFragmentDoc}`;
exports.GetSdkConfigurationDocument = (0, graphql_tag_1.default) `
    query GetSdkConfiguration {
  sdkConfiguration {
    sentryDsn
    isWidgetWatermarkEnabled
  }
}
    `;
exports.GetCustomerPortalByRefIdDocument = (0, graphql_tag_1.default) `
    query GetCustomerPortalByRefId($input: CustomerPortalInput!) {
  customerPortal(input: $input) {
    ...CustomerPortalFragment
  }
}
    ${exports.CustomerPortalFragmentDoc}
${exports.CustomerPortalSubscriptionFragmentDoc}
${exports.CustomerPortalSubscriptionPriceFragmentDoc}
${exports.CustomerPortalSubscriptionAddonFragmentDoc}
${exports.CustomerPortalSubscriptionScheduledUpdateDataFragmentDoc}
${exports.CustomerPortalEntitlementFragmentDoc}
${exports.ResetPeriodConfigurationFragmentDoc}
${exports.FeatureFragmentDoc}
${exports.CustomerPortalPromotionalEntitlementFragmentDoc}
${exports.CustomerPortalBillingInformationFragmentDoc}
${exports.CustomerPortalConfigurationFragmentDoc}
${exports.TypographyConfigurationFragmentDoc}
${exports.FontVariantFragmentDoc}
${exports.CustomerResourceFragmentDoc}`;
exports.GetCheckoutStateDocument = (0, graphql_tag_1.default) `
    query GetCheckoutState($input: CheckoutStateInput!) {
  checkoutState(input: $input) {
    ...CheckoutStateFragment
  }
}
    ${exports.CheckoutStateFragmentDoc}
${exports.CheckoutConfigurationFragmentDoc}
${exports.TypographyConfigurationFragmentDoc}
${exports.FontVariantFragmentDoc}
${exports.CustomerFragmentDoc}
${exports.SlimCustomerFragmentDoc}
${exports.CouponFragmentDoc}
${exports.PromotionalEntitlementFragmentDoc}
${exports.SubscriptionFragmentDoc}
${exports.SubscriptionInvoiceFragmentDoc}
${exports.CustomerResourceFragmentDoc}
${exports.PriceFragmentDoc}
${exports.PriceTierFragmentDoc}
${exports.TotalPriceFragmentDoc}
${exports.PlanFragmentDoc}
${exports.ProductFragmentDoc}
${exports.PackageEntitlementFragmentDoc}
${exports.AddonFragmentDoc}
${exports.SubscriptionScheduledUpdateDataFragmentDoc}
${exports.SubscriptionFutureUpdateDataFragmentDoc}`;
exports.GetMockPaywallDocument = (0, graphql_tag_1.default) `
    query GetMockPaywall($input: GetPaywallInput!) {
  mockPaywall(input: $input) {
    plans {
      ...MockPaywallPlanFragment
    }
    configuration {
      ...PaywallConfigurationFragment
    }
  }
}
    ${exports.MockPaywallPlanFragmentDoc}
${exports.MockPaywallPackageEntitlementFragmentDoc}
${exports.MockPaywallPriceFragmentDoc}
${exports.PriceTierFragmentDoc}
${exports.MockPaywallAddonFragmentDoc}
${exports.PaywallConfigurationFragmentDoc}
${exports.TypographyConfigurationFragmentDoc}
${exports.FontVariantFragmentDoc}
${exports.LayoutConfigurationFragmentDoc}`;
exports.GetUsageHistoryDocument = (0, graphql_tag_1.default) `
    query GetUsageHistory($usageHistoryInput: UsageHistoryInput!) {
  usageHistory(usageHistoryInput: $usageHistoryInput) {
    ...UsageHistoryFragment
  }
}
    ${exports.UsageHistoryFragmentDoc}`;
exports.OnEntitlementsUpdatedDocument = (0, graphql_tag_1.default) `
    subscription OnEntitlementsUpdated {
  entitlementsUpdated {
    ...EntitlementsUpdatedPayload
  }
}
    ${exports.EntitlementsUpdatedPayloadFragmentDoc}
${exports.EntitlementFragmentDoc}
${exports.ResetPeriodConfigurationFragmentDoc}
${exports.FeatureFragmentDoc}`;
exports.OnUsageUpdatedDocument = (0, graphql_tag_1.default) `
    subscription OnUsageUpdated {
  usageUpdated {
    ...EntitlementUsageUpdated
  }
}
    ${exports.EntitlementUsageUpdatedFragmentDoc}
${exports.UsageUpdatedFragmentDoc}
${exports.EntitlementFragmentDoc}
${exports.ResetPeriodConfigurationFragmentDoc}
${exports.FeatureFragmentDoc}`;
const defaultWrapper = (action, _operationName, _operationType) => action();
function getSdk(client, withWrapper = defaultWrapper) {
    return {
        ProvisionCustomer(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.ProvisionCustomerDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ProvisionCustomer', 'mutation');
        },
        ImportCustomerBulk(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.ImportCustomerBulkDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ImportCustomerBulk', 'mutation');
        },
        ImportCustomer(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.ImportCustomerDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ImportCustomer', 'mutation');
        },
        UpdateCustomer(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.UpdateCustomerDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateCustomer', 'mutation');
        },
        GrantPromotionalEntitlements(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GrantPromotionalEntitlementsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GrantPromotionalEntitlements', 'mutation');
        },
        RevokePromotionalEntitlement(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.RevokePromotionalEntitlementDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'RevokePromotionalEntitlement', 'mutation');
        },
        ProvisionSubscription(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.ProvisionSubscriptionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ProvisionSubscription', 'mutation');
        },
        ApplySubscription(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.ApplySubscriptionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ApplySubscription', 'mutation');
        },
        ImportSubscriptionsBulk(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.ImportSubscriptionsBulkDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ImportSubscriptionsBulk', 'mutation');
        },
        UpdateSubscription(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.UpdateSubscriptionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'UpdateSubscription', 'mutation');
        },
        CancelSubscription(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.CancelSubscriptionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CancelSubscription', 'mutation');
        },
        EstimateSubscription(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.EstimateSubscriptionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'EstimateSubscription', 'mutation');
        },
        EstimateSubscriptionUpdate(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.EstimateSubscriptionUpdateDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'EstimateSubscriptionUpdate', 'mutation');
        },
        PreviewSubscription(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.PreviewSubscriptionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'PreviewSubscription', 'mutation');
        },
        CancelSubscriptionUpdates(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.CancelSubscriptionUpdatesDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CancelSubscriptionUpdates', 'mutation');
        },
        ReportUsage(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.ReportUsageDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ReportUsage', 'mutation');
        },
        ReportEvent(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.ReportEventDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ReportEvent', 'mutation');
        },
        ReportEntitlementCheckRequested(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.ReportEntitlementCheckRequestedDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ReportEntitlementCheckRequested', 'mutation');
        },
        CreateSubscription(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.CreateSubscriptionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'CreateSubscription', 'mutation');
        },
        MigrateSubscriptionToLatest(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.MigrateSubscriptionToLatestDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'MigrateSubscriptionToLatest', 'mutation');
        },
        ArchiveCustomer(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.ArchiveCustomerDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'ArchiveCustomer', 'mutation');
        },
        TransferSubscription(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.TransferSubscriptionDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'TransferSubscription', 'mutation');
        },
        GetCustomerById(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetCustomerByIdDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetCustomerById', 'query');
        },
        GetActiveSubscriptions(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetActiveSubscriptionsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetActiveSubscriptions', 'query');
        },
        GetCoupons(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetCouponsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetCoupons', 'query');
        },
        GetPaywall(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetPaywallDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetPaywall', 'query');
        },
        GetEntitlements(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetEntitlementsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetEntitlements', 'query');
        },
        GetEntitlement(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetEntitlementDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetEntitlement', 'query');
        },
        GetProducts(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetProductsDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetProducts', 'query');
        },
        GetSdkConfiguration(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetSdkConfigurationDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetSdkConfiguration', 'query');
        },
        GetCustomerPortalByRefId(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetCustomerPortalByRefIdDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetCustomerPortalByRefId', 'query');
        },
        GetCheckoutState(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetCheckoutStateDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetCheckoutState', 'query');
        },
        GetMockPaywall(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetMockPaywallDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetMockPaywall', 'query');
        },
        GetUsageHistory(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.GetUsageHistoryDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'GetUsageHistory', 'query');
        },
        OnEntitlementsUpdated(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.OnEntitlementsUpdatedDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'OnEntitlementsUpdated', 'subscription');
        },
        OnUsageUpdated(variables, requestHeaders) {
            return withWrapper((wrappedRequestHeaders) => client.request(exports.OnUsageUpdatedDocument, variables, Object.assign(Object.assign({}, requestHeaders), wrappedRequestHeaders)), 'OnUsageUpdated', 'subscription');
        }
    };
}
exports.getSdk = getSdk;
//# sourceMappingURL=sdk.js.map